var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g4, _path9, _g5, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _g6, _g7, _path117, _path118, _path119, _path120, _path121, _path122, _g8, _g9, _path123, _path124, _path125, _path126, _path127, _g10, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _g11, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _g12, _g13, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _g14, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _g15, _path425, _g16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalReportAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 481,
    viewBox: "0 0 366 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3474_12958)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.587 120.587C314.587 120.587 318.366 110.636 319.71 108.012C321.053 105.388 328.548 96.2769 330.668 97.6834C332.788 99.09 328.254 102.848 327.204 105.01C328.191 108.978 335.035 100.266 335.035 100.266C335.035 100.266 337.386 92.6871 338.268 92.6661C339.149 92.6451 344.985 99.9927 345.405 106.648C345.825 113.302 329.744 125.143 323.719 125.667C317.694 126.192 317.064 131.063 317.064 131.063L309.801 125.206L314.566 120.587H314.587Z",
    fill: "#FFCABF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.77 113.617C335.644 113.617 335.518 113.554 335.455 113.449C335.329 113.281 335.392 113.029 335.56 112.924C337.827 111.454 339.108 109.229 340.22 107.277C340.493 106.815 340.745 106.353 340.997 105.954C341.648 104.904 342.299 104.61 342.823 104.359C343.579 103.981 344.965 104.212 345.07 104.38L345.196 104.967C345.028 105.093 344.902 104.967 344.461 104.799C344.02 104.631 342.34 105.219 341.648 106.353C341.396 106.752 341.144 107.193 340.871 107.654C339.758 109.586 338.394 112 335.959 113.575C335.896 113.617 335.812 113.638 335.749 113.638L335.77 113.617Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.615 109.753C334.489 109.753 334.342 109.69 334.279 109.564C334.174 109.375 334.237 109.144 334.426 109.039C338.751 106.646 339.569 103.161 339.989 101.293C340.052 101.02 340.115 100.768 340.178 100.558C340.619 99.0465 342.613 98.9416 343.18 99.0045L343.495 99.6133C343.474 99.8233 342.571 99.6553 342.341 99.6133C342.236 99.6133 341.291 99.5504 340.934 100.747C340.871 100.936 340.829 101.167 340.766 101.44C340.304 103.434 339.443 107.129 334.825 109.69C334.762 109.732 334.699 109.732 334.636 109.732L334.615 109.753Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.209 107.152C333.083 107.152 332.957 107.089 332.894 106.984C332.768 106.816 332.81 106.564 332.999 106.438C336.715 103.898 337.323 101.106 337.701 99.4475L337.764 99.1536C337.953 98.2929 338.562 96.2145 339.801 95.5008C340.241 95.2488 340.43 95.3118 340.934 95.4588L341.396 96.1096C341.333 96.3195 341.207 96.1306 340.997 96.0676C340.724 95.9836 340.451 96.0046 340.199 96.1515C339.402 96.6134 338.814 98.0829 338.541 99.3215L338.478 99.6154C338.079 101.4 337.428 104.36 333.461 107.089C333.398 107.131 333.314 107.152 333.251 107.152H333.209Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.639 370.764L90.8638 401.645L80.5352 399.189L81.5428 367.237L99.639 370.764Z",
    fill: "#1A2E35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7272 388.82C76.2941 386.952 77.0288 385.503 79.0232 386.175L81.8363 387.141C82.8649 387.561 83.3268 388.547 83.9356 389.471C88.4492 396.399 93.3196 391.78 95.7548 392.767C98.8828 394.026 92.8158 403.242 92.7528 403.83L91.4722 416.846C91.3672 417.938 89.9187 419.785 88.764 419.659C88.5541 419.638 88.3652 419.575 88.1553 419.491C82.592 417.245 79.9469 416.174 73.0191 413.361L51.8159 404.796C46.0428 402.466 48.8349 395.349 51.417 395.811C63.0053 397.931 68.6525 396.147 73.208 395.013C73.208 395.013 74.8245 391.696 75.7062 388.82H75.7272Z",
    fill: "#FF8066"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.8371 404.795L73.0403 413.36C79.9681 416.173 82.6132 417.223 88.1764 419.49C88.3654 419.574 88.5753 419.616 88.7852 419.658C89.562 419.763 90.4857 418.923 91.0105 418.042L91.3464 417.16L48.4572 399.819C48.3522 401.688 49.2129 403.745 51.8371 404.816V404.795Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8398 397.029C66.3646 398.141 66.6795 399.359 66.7845 400.577C66.8055 400.871 67.0154 401.101 67.3093 401.101C67.5822 401.101 67.8552 400.85 67.8342 400.577C67.7292 399.149 67.3513 397.785 66.7425 396.483C66.6166 396.231 66.2387 396.147 66.0078 396.294C65.7348 396.441 65.6929 396.756 65.8188 397.029H65.8398Z",
    fill: "#1A2E35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0175 396.355C70.4794 397.363 70.7943 398.559 70.9203 399.651C70.9412 399.924 71.1512 400.197 71.4451 400.176C71.697 400.176 72.0119 399.945 71.9699 399.651C71.823 398.328 71.4661 397.048 70.9203 395.83C70.7943 395.578 70.4164 395.515 70.1855 395.641C69.9126 395.788 69.8706 396.103 69.9965 396.376L70.0175 396.355Z",
    fill: "#1A2E35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1878 395.663C73.1878 395.663 73.2297 395.705 73.2507 395.726C73.2507 395.726 73.3137 395.831 73.3557 395.873C73.4187 395.978 73.4817 396.083 73.5446 396.188C73.6076 396.272 73.6496 396.377 73.6916 396.46C73.7126 396.523 73.7336 396.565 73.7756 396.628C73.7966 396.691 73.7966 396.691 73.7756 396.628C73.7756 396.649 73.7966 396.691 73.8176 396.712C73.9015 396.922 73.9645 397.132 74.0065 397.363C74.0275 397.489 74.0485 397.594 74.0695 397.72C74.0485 397.594 74.0695 397.783 74.0695 397.804C74.0695 397.867 74.0695 397.93 74.0695 397.993C74.0695 398.266 74.3004 398.539 74.5943 398.518C74.8672 398.518 75.1401 398.287 75.1191 397.993C75.0562 396.859 74.6153 395.81 73.9015 394.928C73.7336 394.718 73.3347 394.739 73.1458 394.928C72.9358 395.159 72.9568 395.453 73.1458 395.684L73.1878 395.663Z",
    fill: "#1A2E35"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9092 392.094C74.9512 392.094 74.9722 392.115 75.0141 392.136C75.0771 392.157 75.1191 392.178 75.1821 392.22C75.2871 392.283 75.413 392.325 75.518 392.388C75.7489 392.514 75.9588 392.64 76.1898 392.787C76.2947 392.85 76.3997 392.934 76.5047 392.997C76.5257 392.997 76.5466 393.039 76.5676 393.06C76.6096 393.081 76.6096 393.081 76.5676 393.06C76.6306 393.102 76.6726 393.144 76.7146 393.186C76.9245 393.354 77.1135 393.522 77.2814 393.711C77.4704 393.9 77.8272 393.921 78.0372 393.711C78.2471 393.501 78.2471 393.165 78.0372 392.955C77.2184 392.157 76.2527 391.527 75.2031 391.087C74.9512 390.982 74.6153 391.212 74.5523 391.464C74.4893 391.779 74.6573 392.01 74.9302 392.115L74.9092 392.094Z",
    fill: "#1A2E35"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.9223 396.609C84.5655 397.68 84.4605 398.961 85.1953 399.821C85.6361 400.346 86.3289 400.619 86.9797 400.85C88.9321 401.564 90.8844 402.299 92.8368 403.012L92.8788 402.97C94.2853 400.346 97.8122 394.006 95.419 393.04C93.5296 392.285 90.0027 395.308 86.5388 392.6C85.993 394.069 85.1743 395.896 84.9433 396.609H84.9223Z",
    fill: "#993722"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.237 240.249L173.073 241.677L147.293 247.177C147.293 247.177 104.404 260.907 96.3216 277.597C92.9627 284.524 73.25 382.143 73.25 382.143L101.066 390.561C101.066 390.561 120.317 320.066 120.8 299.43C126.888 295.378 167.426 287.232 171.561 282.446C169.903 288.996 152.584 324.391 154.326 339.905C154.326 339.905 158.105 428.58 160.981 456.06L183.947 456.102C186.446 434.941 190.833 389.197 189.091 349.205C192.534 326.616 216.487 297.393 220.791 278.541C222.47 271.215 219.195 240.229 219.195 240.229L219.237 240.249Z",
    fill: "#192227"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.011 240.922C140.24 250.348 132.809 257.927 123.635 260.677C123.131 260.824 123.341 261.622 123.845 261.475C133.291 258.641 140.912 250.852 143.788 241.153C143.935 240.65 143.158 240.419 143.011 240.943V240.922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.688 248.039C172.045 256.289 172.423 264.561 172.8 272.811C172.842 273.336 172.045 273.42 172.003 272.895C171.814 268.654 171.625 264.414 171.436 260.173C169.651 261.957 167.153 260.32 166.272 258.284C164.844 255.009 164.802 250.957 165.243 247.472C165.306 246.947 166.104 247.073 166.041 247.598C165.726 250.033 165.747 252.51 166.188 254.925C166.398 256.163 166.67 257.57 167.363 258.64C168.14 259.837 169.84 260.74 170.974 259.438C171.1 259.312 171.247 259.27 171.394 259.333C171.226 255.596 171.058 251.839 170.89 248.102C170.848 247.577 171.646 247.493 171.688 248.018V248.039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.281 248.417C200.176 259.355 208.321 268.508 218.86 269.368C219.364 269.41 219.364 268.592 218.86 268.55C208.741 267.731 200.953 258.872 201.058 248.417C201.058 247.892 200.281 247.892 200.26 248.417H200.281Z",
    fill: "black"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.018 433.01L167.469 465.78L178.154 466.326L181.618 434.731L163.018 433.01Z",
    fill: "#192227"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.244 481H163.353C163.353 481 162.828 479.993 163.437 477.327C163.521 476.907 163.647 476.445 163.794 475.962C163.794 475.941 163.794 475.92 163.815 475.878C164.046 475.143 164.298 474.22 164.571 473.254C165.663 469.265 166.418 460.049 166.418 460.049C166.418 460.049 170.932 455.515 175.592 457.635C179.665 459.503 179.035 461.855 179.035 461.855C179.035 461.855 179.098 467.964 182.184 470.714C184.095 472.414 186.005 473.737 186.908 475.857C187.076 476.256 187.223 476.676 187.307 477.138C187.307 477.201 187.328 477.243 187.328 477.306C187.517 478.334 187.517 479.531 187.223 480.979L187.244 481Z",
    fill: "#FF8066"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M163.437 477.328C162.849 479.994 163.353 481.002 163.353 481.002H187.243C187.516 479.553 187.537 478.357 187.348 477.328H163.437Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.733 466.18C176.389 465.131 174.626 465.278 173.408 466.453C173.093 466.768 172.589 466.264 172.904 465.949C174.416 464.48 176.557 464.396 178.216 465.677C178.573 465.949 178.069 466.453 177.712 466.18H177.733Z",
    fill: "#1A2E35"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.406 468.404C177.062 467.354 175.299 467.501 174.081 468.677C173.766 468.992 173.262 468.488 173.577 468.173C175.089 466.704 177.23 466.62 178.889 467.9C179.245 468.173 178.742 468.677 178.385 468.404H178.406Z",
    fill: "#1A2E35"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.077 470.463C177.734 469.413 175.97 469.56 174.752 470.735C174.438 471.05 173.934 470.547 174.249 470.232C175.76 468.762 177.901 468.678 179.56 469.959C179.917 470.232 179.413 470.735 179.056 470.463H179.077Z",
    fill: "#1A2E35"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.076 130.265C164.088 129.824 192.324 126.444 220.959 132.175L220.749 242.138C220.749 242.138 225.2 250.094 216.11 249.612C178.427 253.663 141.583 247.764 141.583 247.764C137.532 246.421 137.532 241.109 141.772 234.496",
    fill: "url(#paint0_linear_3474_12958)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M220.769 242.159L220.979 132.197C192.344 126.444 164.108 129.845 157.097 130.286L141.814 234.539C137.552 241.152 137.552 246.442 141.625 247.807C141.625 247.807 178.468 253.706 216.151 249.654C225.22 250.137 220.79 242.18 220.79 242.18L220.769 242.159Z",
    fill: "#87CDD7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.348 97.4113C155.165 95.9837 156.697 85.3821 155.396 83.0729C154.22 80.9526 153.59 78.5593 153.758 76.1241C154.01 72.5343 155.858 69.9101 157.621 66.9921C157.705 66.8451 157.81 66.6772 157.81 66.5092C157.81 66.2363 157.6 66.0683 157.39 65.9214C156.298 65.0607 153.296 64.8507 153.212 65.1027C155.564 61.8067 162.827 60.4212 166.795 60.6521C165.326 59.2665 164.549 57.1462 164.759 55.1309C167.509 58.1959 171.498 59.6444 175.297 60.988C174.437 59.4975 174.353 57.65 174.311 55.9286C175.759 58.1329 178.194 59.4765 180.693 60.1063C181.847 60.4002 183.044 60.5471 184.219 60.6101C186.235 60.7361 188.103 60.5681 190.056 61.1349C191.546 61.5758 193.037 62.1426 194.422 62.8984C196.312 63.927 198.075 65.3336 199.23 67.202C199.964 68.3566 200.447 69.7002 200.573 71.0647C200.573 71.2117 200.741 72.6392 200.573 72.7232L157.327 97.4323L157.348 97.4113Z",
    fill: "#192227"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M195.807 129.132C195.807 129.132 193.225 120.693 195.891 104.906C195.891 104.906 195.051 104.633 195.03 104.612C195.387 102.408 195.807 100.35 196.227 98.5659C196.227 98.5239 196.227 98.5029 196.227 98.5029L176.829 113.828C177.879 118.656 177.207 128.292 176.619 132.407C176.619 132.407 174.814 139.923 184.45 139.146C191.482 138.579 195.786 129.153 195.786 129.153L195.807 129.132Z",
    fill: "#FFCABF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M177.291 120.735L189.005 116.642C188.354 120.504 185.541 125.312 177.228 126.634C177.228 126.634 177.585 122.352 177.291 120.735Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M195.262 88.3434C195.388 101.758 195.724 109.316 189.426 116.579C179.979 127.496 163.436 122.667 159.322 109.526C155.606 97.7064 156.047 77.7628 168.769 71.6538C181.301 65.6287 195.136 74.9287 195.262 88.3434Z",
    fill: "#FFCABF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M197.341 71.0014C196.606 71.0014 193.268 70.4976 192.554 70.0987C191.526 69.5109 190.455 68.9861 189.363 68.5242C187.306 67.6425 185.144 66.9917 182.939 66.6348C179.16 66.026 175.277 66.3619 171.645 67.6215C166.397 69.4689 161.505 75.7879 159.763 81.3721C161.232 78.8949 161.715 78.0551 163.311 76.6906C165.011 75.389 166.292 74.5913 168.286 75.0531C170.28 75.515 172.065 77.1944 172.254 79.2308C174.416 77.1734 177.67 76.3337 180.546 77.0894C183.716 77.9292 186.634 80.7213 186.529 84.0382C186.466 86.5154 185.983 88.8457 186.214 91.3439C186.802 97.5789 190.098 102.911 195.745 105.808C200.238 103.205 201.476 93.926 202.589 88.9926C204.268 81.645 206.179 70.9174 197.32 70.9804L197.341 71.0014Z",
    fill: "#192227"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M201.308 99.0894C200.489 102.595 198.096 105.387 195.556 106.899C191.714 109.166 189.93 104.904 189.993 100.664C190.077 96.8641 190.854 92.1616 195.178 91.6368C199.44 91.1119 202.253 95.0796 201.308 99.0894Z",
    fill: "#FFCABF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M197.991 95.606C197.404 94.8502 196.27 94.6403 195.367 94.9342C194.444 95.2281 193.73 95.9419 193.205 96.7606C192.596 97.7473 192.239 98.8809 192.176 100.036",
    stroke: "black",
    strokeWidth: 0.776751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M154.744 97.8519C156.109 101.925 158.124 104.129 162.638 104.507C167.151 104.885 169.377 103.73 170.07 99.1325C170.196 98.2508 170.175 97.4531 170.049 96.7183C170.657 96.2564 171.728 95.8366 172.862 96.9912C172.82 97.621 172.862 98.3348 173.051 99.1325C174.1 103.856 176.431 105.409 180.944 105.787C185.458 106.165 187.305 104.297 188.376 100.413C189.572 96.0465 188.103 92.1418 179.978 92.1627C178.824 92.1627 177.711 92.3097 176.745 92.6036C176.368 92.7086 176.032 92.8555 175.696 93.0025C174.079 93.4853 170.657 94.0311 166.27 92.1208C166.039 92.0158 165.808 91.8898 165.577 91.8059C164.653 91.428 163.667 91.1551 162.617 90.9661C154.43 89.5806 153.254 93.2544 154.807 97.8519H154.744ZM179.852 93.9052C186.591 93.9052 187.788 96.9702 186.78 100.371C185.898 103.394 184.345 104.843 180.629 104.528C176.913 104.213 174.961 102.995 174.121 99.3005C173.24 95.4587 176.158 93.8842 179.852 93.9052ZM162.785 92.7086C166.522 93.3174 169.566 95.3957 168.978 99.1115C168.411 102.68 166.543 103.583 162.827 103.268C159.111 102.953 157.432 101.232 156.319 98.0409C155.059 94.451 156.025 91.5749 162.806 92.7086H162.785Z",
    fill: "#077D8B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.347 99.2181L189.341 99.9318L189.887 94.3266L186.738 94.0537L187.347 99.2181Z",
    fill: "#077D8B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M155.563 96.5286L153.611 96.9274L152.645 91.1963L155.773 91.4692L155.563 96.5286Z",
    fill: "#077D8B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M158.944 130.141C158.944 130.141 147.839 130.288 141.94 138.916C136.061 147.565 130.498 187.158 130.498 187.158L104.76 187.095L102.64 200.09C102.64 200.09 118.406 215.289 132.786 212.182C147.167 209.054 150.526 201.434 150.526 201.434L158.923 130.141H158.944Z",
    fill: "url(#paint1_linear_3474_12958)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M158.944 130.141C158.944 130.141 147.839 130.288 141.94 138.916C136.061 147.565 130.498 187.158 130.498 187.158L104.76 187.095L102.64 200.09C102.64 200.09 118.406 215.289 132.786 212.182C147.167 209.054 150.526 201.434 150.526 201.434L158.923 130.141H158.944Z",
    fill: "#87CDD7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M111.814 194.442C114.921 189.488 105.033 183.861 105.033 183.861L93.9907 192.595L105.411 198.179L111.814 194.442Z",
    fill: "#FEA692"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9908 192.616L105.033 183.862L99.2601 177.711L87.21 181.994L93.9908 192.616Z",
    fill: "#FEA692"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M145.719 208.822C148.7 192.133 151.177 175.359 153.171 158.522L145.719 208.822Z",
    fill: "#993722"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M220.958 132.199C220.958 132.199 223.687 132.744 227.759 135.998C231.832 139.252 262.734 152.625 262.734 152.625L310.599 120.106C310.599 120.106 310.368 128.903 322.586 128.567C324.832 128.567 273.714 166.334 268.717 169.797C263.721 173.261 218.543 167.74 218.543 167.74L220.958 132.199Z",
    fill: "#87CDD7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M130.498 187.177C130.498 187.177 136.166 192.677 136.523 196.351C136.523 196.351 137.95 186.757 131.19 182.601L130.498 187.177Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M148.3 207.836L58.9528 196.541C56.6435 196.247 56.3286 193.014 58.5329 192.28L98.567 179.117C98.8819 179.012 99.1968 178.991 99.5327 179.033L188.88 190.327C191.189 190.621 191.504 193.854 189.3 194.589L149.266 207.752C148.951 207.857 148.636 207.878 148.3 207.836Z",
    fill: "#97A2A9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M148.006 203.657L56.0972 192.048C54.3968 191.838 52.9483 190.705 52.3395 189.088L32.039 135.744C31.2622 133.687 32.9417 131.546 35.125 131.819L127.033 143.428C128.734 143.638 130.182 144.771 130.791 146.388L151.092 199.732C151.868 201.789 150.189 203.93 148.006 203.657Z",
    fill: "#BBC2C6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M177.081 128.986C175.087 145.067 193.414 135.494 195.619 128.293C197.76 128.356 199.985 129.301 199.985 129.301C199.985 129.301 193.813 143.66 181.028 141.792C169.041 139.65 174.289 129.091 174.289 129.091C174.289 129.091 176.011 128.881 177.081 128.986Z",
    fill: "#ECEDEF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M357.987 188.306L318.916 194.712C317.977 194.866 317.341 195.751 317.495 196.689L323.476 233.171C323.63 234.109 324.515 234.745 325.453 234.591L364.525 228.186C365.463 228.032 366.099 227.147 365.945 226.209L359.965 189.727C359.811 188.789 358.926 188.153 357.987 188.306Z",
    fill: "#FFEFEA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M318.976 208.128L322.334 207.583C323.405 207.415 324.161 206.344 324.182 205.042C324.224 201.075 324.266 197.128 324.308 193.16L317.569 194.273C317.38 194.315 317.233 194.483 317.212 194.735C316.897 198.136 316.561 201.515 316.246 204.916C316.079 206.764 317.443 208.401 318.976 208.149V208.128Z",
    fill: "#FFCABF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M326.932 206.826L330.396 206.259C331.551 206.07 332.328 204.852 332.223 203.446C331.929 199.646 331.656 195.825 331.362 192.025L324.308 193.18C324.266 196.749 324.224 200.318 324.203 203.866C324.203 205.629 325.505 207.057 326.953 206.826H326.932Z",
    fill: "#FEA692"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M334.909 205.525L338.415 204.959C339.654 204.749 340.451 203.363 340.22 201.852C339.612 198.199 339.024 194.546 338.415 190.872L331.361 192.027C331.634 195.638 331.907 199.248 332.18 202.859C332.306 204.497 333.587 205.735 334.909 205.525Z",
    fill: "#FFCABF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M342.929 204.202L346.435 203.635C347.779 203.425 348.576 201.83 348.177 200.234C347.275 196.729 346.393 193.223 345.49 189.717L338.437 190.871C339.045 194.524 339.633 198.177 340.242 201.851C340.494 203.362 341.69 204.433 342.929 204.223V204.202Z",
    fill: "#FEA692"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M350.969 202.903L354.433 202.336C355.861 202.105 356.659 200.321 356.092 198.662C354.916 195.303 353.741 191.923 352.565 188.564L345.511 189.719C346.456 193.414 347.401 197.109 348.345 200.825C348.702 202.189 349.836 203.092 350.99 202.903H350.969Z",
    fill: "#FFCABF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M359.031 201.579L362.39 201.033C363.922 200.781 364.699 198.787 363.943 197.107C362.558 194 361.172 190.893 359.787 187.765C359.682 187.555 359.493 187.43 359.304 187.451L352.565 188.563C353.867 192.3 355.168 196.037 356.47 199.774C356.89 201.012 357.96 201.747 359.031 201.579Z",
    fill: "#FEA692"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M335.97 210.478L346.908 208.685C348.358 208.447 349.733 209.435 349.97 210.885L353.136 230.193L336.956 232.845L333.791 213.537C333.553 212.087 334.54 210.713 335.99 210.475L335.97 210.478Z",
    fill: "#FEA692"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M261.548 65.3411C268.238 66.2693 274.413 61.5988 275.341 54.9092C276.269 48.2197 271.599 42.0443 264.909 41.1162C258.22 40.188 252.044 44.8585 251.116 51.548C250.188 58.2376 254.859 64.4129 261.548 65.3411Z",
    fill: "#FFD485"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M261.863 63.0741C267.301 63.8286 272.321 60.0318 273.076 54.5937C273.83 49.1556 270.033 44.1354 264.595 43.3809C259.157 42.6263 254.137 46.4231 253.382 51.8613C252.628 57.2994 256.425 62.3195 261.863 63.0741Z",
    fill: "#FFC86A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M263.502 56.8632C263.127 57.0347 262.696 57.0707 262.211 56.9608C262.18 56.9565 262.156 56.9745 262.153 56.9954L261.952 57.5209C261.952 57.5209 261.924 57.5703 261.902 57.5778C261.879 57.5853 261.847 57.5914 261.827 57.5781L261.021 57.2534C261.021 57.2534 260.972 57.2252 260.964 57.2029C260.956 57.1806 260.95 57.1478 260.964 57.1284L261.185 56.6057C261.185 56.6057 261.191 56.5639 261.163 56.5387C260.743 56.2675 260.459 55.9303 260.321 55.5492C260.173 55.1562 260.186 54.7536 260.363 54.3205L260.431 54.1384C260.431 54.1384 260.459 54.089 260.482 54.0815C260.504 54.074 260.537 54.0679 260.556 54.0812L261.422 54.4355C261.422 54.4355 261.472 54.4636 261.479 54.486C261.487 54.5083 261.493 54.5411 261.48 54.5605L261.431 54.6815C261.348 54.8935 261.37 55.12 261.489 55.3387C261.618 55.5588 261.848 55.7398 262.171 55.8697C262.442 55.9819 262.674 56.0033 262.854 55.9325C263.034 55.8617 263.157 55.7405 263.234 55.5702C263.284 55.4388 263.291 55.3121 263.243 55.199C263.195 55.0858 263.117 54.958 263.006 54.8361C262.895 54.7143 262.708 54.5287 262.443 54.2898C262.15 54.0256 261.907 53.7791 261.714 53.5607C261.533 53.3333 261.398 53.0804 261.331 52.7945C261.254 52.507 261.285 52.2028 261.417 51.8698C261.58 51.4562 261.845 51.1629 262.208 51.0004C262.562 50.8261 262.972 50.7871 263.427 50.8822C263.458 50.8866 263.482 50.8686 263.485 50.8477L263.706 50.2505C263.706 50.2505 263.734 50.2011 263.756 50.1936C263.779 50.1861 263.812 50.18 263.831 50.1933L264.637 50.518C264.637 50.518 264.687 50.5462 264.694 50.5685C264.702 50.5908 264.708 50.6236 264.694 50.643L264.44 51.2464C264.44 51.2464 264.435 51.2881 264.463 51.3134C264.873 51.583 265.145 51.9189 265.292 52.3223C265.438 52.7257 265.423 53.1388 265.246 53.5718L265.197 53.6928C265.197 53.6928 265.169 53.7421 265.147 53.7496C265.124 53.7572 265.092 53.7633 265.072 53.7499L264.196 53.3942C264.196 53.3942 264.146 53.3661 264.139 53.3437C264.131 53.3214 264.125 53.2886 264.139 53.2692L264.168 53.2094C264.263 52.9884 264.253 52.7529 264.136 52.5238C264.018 52.2946 263.809 52.1166 263.506 52C263.264 51.9026 263.054 51.8841 262.876 51.934C262.699 51.9839 262.576 52.1051 262.496 52.2963C262.446 52.4277 262.439 52.5544 262.475 52.6766C262.512 52.7987 262.6 52.928 262.73 53.0631C262.861 53.1983 263.057 53.3958 263.341 53.6481C263.643 53.9242 263.877 54.1588 264.052 54.3534C264.217 54.5465 264.344 54.7771 264.422 55.0645C264.5 55.3415 264.478 55.6576 264.336 55.9892C264.159 56.4222 263.895 56.7155 263.519 56.887L263.502 56.8632Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M290.22 45.1972C294.486 43.6799 296.715 38.9913 295.197 34.7248C293.68 30.4584 288.992 28.2297 284.725 29.7469C280.459 31.2642 278.23 35.9528 279.747 40.2193C281.264 44.4857 285.953 46.7144 290.22 45.1972Z",
    fill: "#FFD485"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M289.706 43.7515C293.174 42.5181 294.986 38.7066 293.753 35.2382C292.519 31.7699 288.708 29.9581 285.239 31.1915C281.771 32.4249 279.959 36.2365 281.193 39.7048C282.426 43.1731 286.238 44.9849 289.706 43.7515Z",
    fill: "#FFC86A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M288.759 39.5496C288.589 39.7676 288.344 39.9222 288.021 40.0069C288.002 40.014 287.993 40.0321 287.998 40.0454L288.041 40.4201C288.041 40.4201 288.039 40.4582 288.028 40.4696C288.018 40.4809 288 40.4947 287.984 40.4928L287.404 40.5491C287.404 40.5491 287.366 40.5476 287.355 40.5366C287.343 40.5257 287.329 40.5081 287.331 40.4924L287.302 40.1129C287.302 40.1129 287.292 40.0863 287.267 40.0801C286.934 40.0487 286.661 39.9357 286.46 39.7519C286.251 39.5638 286.134 39.3202 286.106 39.0078L286.09 38.8784C286.09 38.8784 286.091 38.8404 286.102 38.829C286.113 38.8176 286.131 38.8038 286.146 38.8058L286.771 38.7486C286.771 38.7486 286.809 38.7501 286.821 38.761C286.832 38.772 286.846 38.7896 286.844 38.8053L286.852 38.8923C286.869 39.044 286.952 39.172 287.09 39.2654C287.235 39.3564 287.428 39.3928 287.66 39.3703C287.856 39.3529 288.001 39.2942 288.086 39.1964C288.171 39.0985 288.207 38.9883 288.2 38.8632C288.189 38.7695 288.154 38.692 288.09 38.6396C288.027 38.5872 287.941 38.5353 287.837 38.4971C287.734 38.4589 287.565 38.4064 287.333 38.3462C287.077 38.2797 286.857 38.2081 286.674 38.138C286.496 38.0588 286.337 37.9502 286.209 37.8007C286.074 37.6536 285.999 37.4629 285.974 37.2242C285.944 36.9274 286.01 36.6713 286.176 36.4623C286.333 36.249 286.564 36.0991 286.864 36.0149C286.884 36.0077 286.893 35.9897 286.888 35.9764L286.835 35.5527C286.835 35.5527 286.837 35.5146 286.847 35.5032C286.858 35.4918 286.876 35.4781 286.892 35.48L287.472 35.4237C287.472 35.4237 287.51 35.4252 287.521 35.4362C287.533 35.4471 287.546 35.4647 287.545 35.4804L287.58 35.9179C287.58 35.9179 287.59 35.9445 287.614 35.9507C287.941 35.9845 288.207 36.0999 288.419 36.2946C288.631 36.4894 288.75 36.7396 288.779 37.052L288.787 37.1391C288.787 37.1391 288.786 37.1771 288.775 37.1885C288.764 37.1999 288.746 37.2136 288.73 37.2117L288.099 37.2712C288.099 37.2712 288.061 37.2698 288.049 37.2588C288.038 37.2479 288.024 37.2303 288.026 37.2146L288.025 37.1699C288.013 37.0092 287.934 36.8721 287.794 36.7721C287.653 36.672 287.474 36.6309 287.257 36.6553C287.083 36.6722 286.952 36.7263 286.862 36.8108C286.772 36.8953 286.737 37.0055 286.748 37.1439C286.759 37.2376 286.794 37.3151 286.854 37.3765C286.913 37.438 287.006 37.4875 287.125 37.5276C287.244 37.5677 287.422 37.6246 287.669 37.6867C287.934 37.7574 288.146 37.8247 288.31 37.8863C288.468 37.9502 288.615 38.0479 288.75 38.195C288.882 38.3354 288.967 38.5305 288.985 38.7716C289.014 39.084 288.947 39.3402 288.777 39.5582L288.759 39.5496Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66165 84.4355H13.4824L13.4824 71.9656H9.66165L9.66165 84.4355Z",
    fill: "#DCDCDC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5035 84.4355H28.8496V71.9656H13.5035L13.5035 84.4355Z",
    fill: "#ECECEC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9048 73.8125H28.0728V73.3716H27.9048V73.8125Z",
    fill: "#C8C8C8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9942 73.8125H26.1621V73.3716H25.9942V73.8125Z",
    fill: "#C8C8C8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0845 73.8125H24.2524V73.3716H24.0845V73.8125Z",
    fill: "#C8C8C8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1739 73.8125H22.3418V73.3716H22.1739V73.8125Z",
    fill: "#C8C8C8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2627 73.8125H20.4307V73.3716H20.2627V73.8125Z",
    fill: "#C8C8C8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3316 73.8125H18.4995V73.3716H18.3316V73.8125Z",
    fill: "#C8C8C8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4204 73.8125H16.5884V73.3716H16.4204V73.8125Z",
    fill: "#C8C8C8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5113 73.8125H14.6792V73.3716H14.5113V73.8125Z",
    fill: "#C8C8C8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9048 76.499H28.0728V76.0582H27.9048V76.499Z",
    fill: "#C8C8C8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9942 76.499H26.1621V76.0582H25.9942V76.499Z",
    fill: "#C8C8C8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0845 76.499H24.2524V76.0582H24.0845V76.499Z",
    fill: "#C8C8C8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1739 76.499H22.3418V76.0582H22.1739V76.499Z",
    fill: "#C8C8C8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2627 76.499H20.4307V76.0582H20.2627V76.499Z",
    fill: "#C8C8C8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3316 76.499H18.4995V76.0582H18.3316V76.499Z",
    fill: "#C8C8C8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4204 76.499H16.5884V76.0582H16.4204V76.499Z",
    fill: "#C8C8C8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5113 76.499H14.6792V76.0582H14.5113V76.499Z",
    fill: "#C8C8C8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9048 79.1885H28.0728V78.7476H27.9048V79.1885Z",
    fill: "#C8C8C8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9942 79.1885H26.1621V78.7476H25.9942V79.1885Z",
    fill: "#C8C8C8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0845 79.1885H24.2524V78.7476H24.0845V79.1885Z",
    fill: "#C8C8C8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1739 79.1885H22.3418V78.7476H22.1739V79.1885Z",
    fill: "#C8C8C8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2627 79.1885H20.4307V78.7476H20.2627V79.1885Z",
    fill: "#C8C8C8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3316 79.1885H18.4995V78.7476H18.3316V79.1885Z",
    fill: "#C8C8C8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4204 79.1885H16.5884V78.7476H16.4204V79.1885Z",
    fill: "#C8C8C8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5113 79.1885H14.6792V78.7476H14.5113V79.1885Z",
    fill: "#C8C8C8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9048 81.917H28.0728V81.4761H27.9048V81.917Z",
    fill: "#C8C8C8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9942 81.917H26.1621V81.4761H25.9942V81.917Z",
    fill: "#C8C8C8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0845 81.917H24.2524V81.4761H24.0845V81.917Z",
    fill: "#C8C8C8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1739 81.917H22.3418V81.4761H22.1739V81.917Z",
    fill: "#C8C8C8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2627 81.917H20.4307V81.4761H20.2627V81.917Z",
    fill: "#C8C8C8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3316 81.917H18.4995V81.4761H18.3316V81.917Z",
    fill: "#C8C8C8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4204 81.917H16.5884V81.4761H16.4204V81.917Z",
    fill: "#C8C8C8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5113 81.917H14.6792V81.4761H14.5113V81.917Z",
    fill: "#C8C8C8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4243 73.8125H11.5923V73.3716H11.4243V73.8125Z",
    fill: "#C8C8C8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4243 76.499H11.5923V76.0582H11.4243V76.499Z",
    fill: "#C8C8C8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4243 79.1885H11.5923V78.7476H11.4243V79.1885Z",
    fill: "#C8C8C8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4243 81.917H11.5923V81.4761H11.4243V81.917Z",
    fill: "#C8C8C8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2524 69.5078H27.3998L26.77 71.964H15.6226L16.2524 69.5078Z",
    fill: "#DCDCDC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4604 69.5078H16.2526L15.6228 71.964H13.4604V69.5078Z",
    fill: "#C8C8C8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5893 69.8242H26.897L26.4351 71.6506H16.1274L16.5893 69.8242Z",
    fill: "#5E6F7A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7632 71.6506H25.8891L26.351 69.8242H26.204L25.7632 71.6506Z",
    fill: "#DCDCDC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0073 71.6506H25.1333L25.5951 69.8242H25.4692L25.0073 71.6506Z",
    fill: "#DCDCDC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M24.252 71.6506H24.3779L24.8398 69.8242H24.7138L24.252 71.6506Z",
    fill: "#DCDCDC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4956 71.6506H23.6216L24.0834 69.8242H23.9575L23.4956 71.6506Z",
    fill: "#DCDCDC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7397 71.6506H22.8657L23.3276 69.8242H23.2016L22.7397 71.6506Z",
    fill: "#DCDCDC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9854 71.6506H22.1113L22.5732 69.8242H22.4472L21.9854 71.6506Z",
    fill: "#DCDCDC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 71.6506H21.3555L21.8173 69.8242H21.6913L21.2295 71.6506Z",
    fill: "#DCDCDC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4731 71.6506H20.5991L21.061 69.8242H20.935L20.4731 71.6506Z",
    fill: "#DCDCDC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7168 71.6506H19.8428L20.3046 69.8242H20.1786L19.7168 71.6506Z",
    fill: "#DCDCDC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9614 71.6506H19.0874L19.5492 69.8242H19.4233L18.9614 71.6506Z",
    fill: "#DCDCDC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2061 71.6506H18.332L18.7939 69.8242H18.6679L18.2061 71.6506Z",
    fill: "#DCDCDC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4497 71.6506H17.5757L18.0375 69.8242H17.9116L17.4497 71.6506Z",
    fill: "#DCDCDC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6943 71.6506H16.8203L17.2821 69.8242H17.1562L16.6943 71.6506Z",
    fill: "#DCDCDC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2324 70.8096H26.771V70.6836H16.2324V70.8096Z",
    fill: "#DCDCDC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9877 69.4854H19.7168V65.1817H16.9877V69.4854Z",
    fill: "#FFCABF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9877 69.4854H19.7168V68.4987H16.9877V69.4854Z",
    fill: "#ECECEC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9877 67.8271H19.7168V66.8405H16.9877V67.8271Z",
    fill: "#ECECEC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.9884 69.4854H18.0381V65.1817H16.9884V69.4854Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2955 83.6172H53.3262V79.0617H49.2955V83.6172Z",
    fill: "#FFCABF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.2955 83.6172H53.3262V79.0617H49.2955V83.6172Z",
    fill: "#FFFDFC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.6948 83.2812H52.9697V79.4185H49.6948V83.2812Z",
    fill: "#FFCABF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.2476 83.2812H51.4155V79.4185H51.2476V83.2812Z",
    fill: "#FFCABF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5397 83.6172H49.3169V79.0617H37.5397V83.6172Z",
    fill: "#FFCABF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.5397 83.6172H49.3169V79.0617H37.5397V83.6172Z",
    fill: "#FFFDFC"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.876 83.2793H48.9395V79.4165H37.876V83.2793Z",
    fill: "#FFCABF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7715 83.2793H48.9395V79.4165H48.7715V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4146 83.2793H48.5825V79.4165H48.4146V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0576 83.2793H48.2256V79.4165H48.0576V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6997 83.2793H47.8677V79.4165H47.6997V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3228 83.2793H47.4907V79.4165H47.3228V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9444 83.2793H47.1123V79.4165H46.9444V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6089 83.2793H46.7769V79.4165H46.6089V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.231 83.2793H46.3989V79.4165H46.231V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.874 83.2793H46.042V79.4165H45.874V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5176 83.2793H45.6855V79.4165H45.5176V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1597 83.2793H45.3276V79.4165H45.1597V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7827 83.2793H44.9507V79.4165H44.7827V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4043 83.2793H44.5723V79.4165H44.4043V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0679 83.2793H44.2358V79.4165H44.0679V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6905 83.2793H43.8584V79.4165H43.6905V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3335 83.2793H43.5015V79.4165H43.3335V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9761 83.2793H43.144V79.4165H42.9761V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6192 83.2793H42.7871V79.4165H42.6192V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2427 83.2793H42.4106V79.4165H42.2427V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8858 83.2793H42.0537V79.4165H41.8858V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5283 83.2793H41.6963V79.4165H41.5283V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1504 83.2793H41.3184V79.4165H41.1504V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7945 83.2793H40.9624V79.4165H40.7945V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4156 83.2793H40.5835V79.4165H40.4156V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0796 83.2793H40.2476V79.4165H40.0796V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7022 83.2793H39.8701V79.4165H39.7022V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3447 83.2793H39.5127V79.4165H39.3447V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9878 83.2793H39.1558V79.4165H38.9878V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6109 83.2793H38.7788V79.4165H38.6109V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.253 83.2793H38.4209V79.4165H38.253V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.876 83.2793H38.0439V79.4165H37.876V83.2793Z",
    fill: "black"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3492 74.5283H49.3799V69.9728H45.3492V74.5283Z",
    fill: "#FFCABF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.3492 74.5283H49.3799V69.9728H45.3492V74.5283Z",
    fill: "#FFFDFC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.727 74.1924H49.002V70.3296H45.727V74.1924Z",
    fill: "#FFCABF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.2808 74.1924H47.4487V70.3296H47.2808V74.1924Z",
    fill: "#FFCABF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5929 74.5283H45.3701V69.9728H33.5929V74.5283Z",
    fill: "#FFCABF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.5929 74.5283H45.3701V69.9728H33.5929V74.5283Z",
    fill: "#FFFDFC"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9297 74.1924H44.9932V70.3296H33.9297V74.1924Z",
    fill: "#FFCABF"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8238 74.1924H44.9917V70.3296H44.8238V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4678 74.1924H44.6357V70.3296H44.4678V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0904 74.1924H44.2583V70.3296H44.0904V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7539 74.1924H43.9219V70.3296H43.7539V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.376 74.1924H43.5439V70.3296H43.376V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0191 74.1924H43.187V70.3296H43.0191V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6626 74.1924H42.8306V70.3296H42.6626V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3057 74.1924H42.4736V70.3296H42.3057V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9273 74.1924H42.0952V70.3296H41.9273V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5503 74.1924H41.7183V70.3296H41.5503V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2134 74.1924H41.3813V70.3296H41.2134V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8355 74.1924H41.0034V70.3296H40.8355V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4795 74.1924H40.6475V70.3296H40.4795V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1226 74.1924H40.2905V70.3296H40.1226V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7656 74.1924H39.9336V70.3296H39.7656V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3877 74.1924H39.5557V70.3296H39.3877V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0308 74.1924H39.1987V70.3296H39.0308V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6743 74.1924H38.8423V70.3296H38.6743V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2954 74.1924H38.4634V70.3296H38.2954V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.939 74.1924H38.1069V70.3296H37.939V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5821 74.1924H37.75V70.3296H37.5821V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2251 74.1924H37.3931V70.3296H37.2251V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8472 74.1924H37.0151V70.3296H36.8472V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4903 74.1924H36.6582V70.3296H36.4903V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1338 74.1924H36.3018V70.3296H36.1338V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7559 74.1924H35.9238V70.3296H35.7559V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3989 74.1924H35.5669V70.3296H35.3989V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0205 74.1924H35.1885V70.3296H35.0205V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6861 74.1924H34.854V70.3296H34.6861V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3067 74.1924H34.4746V70.3296H34.3067V74.1924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9502 74.1924H34.1182V70.3296H33.9502V74.1924Z",
    fill: "black"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4273 79.0625H51.458V74.507H47.4273V79.0625Z",
    fill: "#FFCABF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.8051 78.7266H51.0801V74.8638H47.8051V78.7266Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.3584 78.7266H49.5264V74.8638H49.3584V78.7266Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6281 79.0625H47.4053V74.507H35.6281V79.0625Z",
    fill: "#FFCABF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.6281 79.0625H47.4053V74.507H35.6281V79.0625Z",
    fill: "black"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9839 78.7275H47.0474V74.8648H35.9839V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.9839 78.7275H47.0474V74.8648H35.9839V78.7275Z",
    fill: "black"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.9009 78.7275H47.0688V74.8648H46.9009V78.7275Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.5225 78.7275H46.6904V74.8648H46.5225V78.7275Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.1656 78.7275H46.3335V74.8648H46.1656V78.7275Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.8086 78.7275H45.9766V74.8648H45.8086V78.7275Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.4522 78.7275H45.6201V74.8648H45.4522V78.7275Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.0738 78.7275H45.2417V74.8648H45.0738V78.7275Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.6973 78.7275H44.8652V74.8648H44.6973V78.7275Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.3604 78.7275H44.5283V74.8648H44.3604V78.7275Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.9824 78.7275H44.1504V74.8648H43.9824V78.7275Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.6255 78.7275H43.7935V74.8648H43.6255V78.7275Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.2686 78.7275H43.4365V74.8648H43.2686V78.7275Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.9126 78.7275H43.0806V74.8648H42.9126V78.7275Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.5342 78.7275H42.7021V74.8648H42.5342V78.7275Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.1773 78.7275H42.3452V74.8648H42.1773V78.7275Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.8203 78.7275H41.9883V74.8648H41.8203V78.7275Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.4424 78.7275H41.6104V74.8648H41.4424V78.7275Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.0855 78.7275H41.2534V74.8648H41.0855V78.7275Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.7071 78.7275H40.875V74.8648H40.7071V78.7275Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.3721 78.7275H40.54V74.8648H40.3721V78.7275Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.9937 78.7275H40.1616V74.8648H39.9937V78.7275Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.6367 78.7275H39.8047V74.8648H39.6367V78.7275Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.2798 78.7275H39.4478V74.8648H39.2798V78.7275Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.9243 78.7275H39.0923V74.8648H38.9243V78.7275Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.5449 78.7275H38.7129V74.8648H38.5449V78.7275Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.167 78.7275H38.335V74.8648H38.167V78.7275Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.8316 78.7275H37.9995V74.8648H37.8316V78.7275Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.4536 78.7275H37.6216V74.8648H37.4536V78.7275Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.0967 78.7275H37.2646V74.8648H37.0967V78.7275Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.7407 78.7275H36.9087V74.8648H36.7407V78.7275Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.3828 78.7275H36.5508V74.8648H36.3828V78.7275Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.0059 78.7275H36.1738V74.8648H36.0059V78.7275Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0157 79.0635H44.0464V74.5079H40.0157V79.0635Z",
    fill: "#5E6F7A"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3945 78.7266H43.6694V74.8638H40.3945V78.7266Z",
    fill: "#5E6F7A"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9478 78.7266H42.1157V74.8638H41.9478V78.7266Z",
    fill: "#5E6F7A"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2394 79.0635H40.0166V74.5079H28.2394V79.0635Z",
    fill: "#5E6F7A"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5962 78.7256H39.6597V74.8628H28.5962V78.7256Z",
    fill: "#5E6F7A"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.5962 78.7256H39.6597V74.8628H28.5962V78.7256Z",
    fill: "#5E6F7A"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.4922 78.7256H39.6602V74.8628H39.4922V78.7256Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.1133 78.7256H39.2812V74.8628H39.1133V78.7256Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.7569 78.7256H38.9248V74.8628H38.7569V78.7256Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.3804 78.7256H38.5483V74.8628H38.3804V78.7256Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.0435 78.7256H38.2114V74.8628H38.0435V78.7256Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.666 78.7256H37.834V74.8628H37.666V78.7256Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.3091 78.7256H37.4771V74.8628H37.3091V78.7256Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.9522 78.7256H37.1201V74.8628H36.9522V78.7256Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.5957 78.7256H36.7637V74.8628H36.5957V78.7256Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.2178 78.7256H36.3857V74.8628H36.2178V78.7256Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.8389 78.7256H36.0068V74.8628H35.8389V78.7256Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.5039 78.7256H35.6719V74.8628H35.5039V78.7256Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.1255 78.7256H35.2935V74.8628H35.1255V78.7256Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.7686 78.7256H34.9365V74.8628H34.7686V78.7256Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.4121 78.7256H34.5801V74.8628H34.4121V78.7256Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.0552 78.7256H34.2231V74.8628H34.0552V78.7256Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.6773 78.7256H33.8452V74.8628H33.6773V78.7256Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.2989 78.7256H33.4668V74.8628H33.2989V78.7256Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.9634 78.7256H33.1313V74.8628H32.9634V78.7256Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.585 78.7256H32.7529V74.8628H32.585V78.7256Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.229 78.7256H32.397V74.8628H32.229V78.7256Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.8721 78.7256H32.04V74.8628H31.8721V78.7256Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.5152 78.7256H31.6831V74.8628H31.5152V78.7256Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.1367 78.7256H31.3047V74.8628H31.1367V78.7256Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.7798 78.7256H30.9478V74.8628H30.7798V78.7256Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.4234 78.7256H30.5913V74.8628H30.4234V78.7256Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.0449 78.7256H30.2129V74.8628H30.0449V78.7256Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.6885 78.7256H29.8564V74.8628H29.6885V78.7256Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.3106 78.7256H29.4785V74.8628H29.3106V78.7256Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.9741 78.7256H29.1421V74.8628H28.9741V78.7256Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.5967 78.7256H28.7646V74.8628H28.5967V78.7256Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6485 83.6191H47.6792V79.0636H43.6485V83.6191Z",
    fill: "#5E6F7A"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0273 83.2822H47.3022V79.4195H44.0273V83.2822Z",
    fill: "#5E6F7A"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5801 83.2822H45.748V79.4195H45.5801V83.2822Z",
    fill: "#5E6F7A"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8712 83.6191H43.6484V79.0636H31.8712V83.6191Z",
    fill: "#5E6F7A"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M32.208 83.2812H43.2715V79.4185H32.208V83.2812Z",
    fill: "#5E6F7A"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.208 83.2812H43.2715V79.4185H32.208V83.2812Z",
    fill: "#5E6F7A"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.1245 83.2812H43.2925V79.4185H43.1245V83.2812Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.7456 83.2812H42.9136V79.4185H42.7456V83.2812Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.3892 83.2812H42.5571V79.4185H42.3892V83.2812Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.0322 83.2812H42.2002V79.4185H42.0322V83.2812Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.6543 83.2812H41.8223V79.4185H41.6543V83.2812Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.2974 83.2812H41.4653V79.4185H41.2974V83.2812Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.9204 83.2812H41.0884V79.4185H40.9204V83.2812Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.584 83.2812H40.752V79.4185H40.584V83.2812Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.2056 83.2812H40.3735V79.4185H40.2056V83.2812Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.8487 83.2812H40.0166V79.4185H39.8487V83.2812Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.4917 83.2812H39.6597V79.4185H39.4917V83.2812Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.1138 83.2812H39.2817V79.4185H39.1138V83.2812Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.7573 83.2812H38.9253V79.4185H38.7573V83.2812Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.3789 83.2812H38.5469V79.4185H38.3789V83.2812Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.0435 83.2812H38.2114V79.4185H38.0435V83.2812Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.6656 83.2812H37.8335V79.4185H37.6656V83.2812Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.3086 83.2812H37.4766V79.4185H37.3086V83.2812Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.9522 83.2812H37.1201V79.4185H36.9522V83.2812Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.5952 83.2812H36.7632V79.4185H36.5952V83.2812Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.2168 83.2812H36.3848V79.4185H36.2168V83.2812Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.8389 83.2812H36.0068V79.4185H35.8389V83.2812Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.503 83.2812H35.6709V79.4185H35.503V83.2812Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.125 83.2812H35.293V79.4185H35.125V83.2812Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.7681 83.2812H34.936V79.4185H34.7681V83.2812Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.4121 83.2812H34.5801V79.4185H34.4121V83.2812Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.0552 83.2812H34.2231V79.4185H34.0552V83.2812Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.6773 83.2812H33.8452V79.4185H33.6773V83.2812Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.2989 83.2812H33.4668V79.4185H33.2989V83.2812Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.9639 83.2812H33.1318V79.4185H32.9639V83.2812Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.585 83.2812H32.7529V79.4185H32.585V83.2812Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.229 83.2812H32.397V79.4185H32.229V83.2812Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M37.855 83.6172H41.8857V79.0617H37.855V83.6172Z",
    fill: "#FFCABF"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.2319 83.2812H41.5068V79.4185H38.2319V83.2812Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.7862 83.2812H39.9541V79.4185H39.7862V83.2812Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0568 83.6172H37.834V79.0617H26.0568V83.6172Z",
    fill: "#FFCABF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26.0568 83.6172H37.834V79.0617H26.0568V83.6172Z",
    fill: "black"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4136 83.2793H37.4771V79.4165H26.4136V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26.4136 83.2793H37.4771V79.4165H26.4136V83.2793Z",
    fill: "black"
  }))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.3081 83.2793H37.4761V79.4165H37.3081V83.2793Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.9517 83.2793H37.1196V79.4165H36.9517V83.2793Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.5952 83.2793H36.7632V79.4165H36.5952V83.2793Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.2178 83.2793H36.3857V79.4165H36.2178V83.2793Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.8604 83.2793H36.0283V79.4165H35.8604V83.2793Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.5034 83.2793H35.6714V79.4165H35.5034V83.2793Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.127 83.2793H35.2949V79.4165H35.127V83.2793Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.7681 83.2793H34.936V79.4165H34.7681V83.2793Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.3916 83.2793H34.5596V79.4165H34.3916V83.2793Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.0547 83.2793H34.2227V79.4165H34.0547V83.2793Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.6773 83.2793H33.8452V79.4165H33.6773V83.2793Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.3203 83.2793H33.4883V79.4165H33.3203V83.2793Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.9639 83.2793H33.1318V79.4165H32.9639V83.2793Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.5855 83.2793H32.7534V79.4165H32.5855V83.2793Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.229 83.2793H32.397V79.4165H32.229V83.2793Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.8511 83.2793H32.019V79.4165H31.8511V83.2793Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.5152 83.2793H31.6831V79.4165H31.5152V83.2793Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.1367 83.2793H31.3047V79.4165H31.1367V83.2793Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.7798 83.2793H30.9478V79.4165H30.7798V83.2793Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.4234 83.2793H30.5913V79.4165H30.4234V83.2793Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.0664 83.2793H30.2344V79.4165H30.0664V83.2793Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.6885 83.2793H29.8564V79.4165H29.6885V83.2793Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.3111 83.2793H29.479V79.4165H29.3111V83.2793Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.9746 83.2793H29.1426V79.4165H28.9746V83.2793Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.5967 83.2793H28.7646V79.4165H28.5967V83.2793Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.2403 83.2793H28.4082V79.4165H28.2403V83.2793Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.8833 83.2793H28.0513V79.4165H27.8833V83.2793Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.5264 83.2793H27.6943V79.4165H27.5264V83.2793Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.148 83.2793H27.3159V79.4165H27.148V83.2793Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26.791 83.2793H26.959V79.4165H26.791V83.2793Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26.4351 83.2793H26.603V79.4165H26.4351V83.2793Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9996 79.0625H39.0303V74.507H34.9996V79.0625Z",
    fill: "#FFCABF"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.9996 79.0625H39.0303V74.507H34.9996V79.0625Z",
    fill: "#FFFDFC"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.3774 78.7266H38.6523V74.8638H35.3774V78.7266Z",
    fill: "#FFCABF"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.9317 78.7266H37.0996V74.8638H36.9317V78.7266Z",
    fill: "#FFCABF"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2438 79.0625H35.021V74.507H23.2438V79.0625Z",
    fill: "#FFCABF"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.2438 79.0625H35.021V74.507H23.2438V79.0625Z",
    fill: "#FFFDFC"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5791 78.7275H34.6426V74.8648H23.5791V78.7275Z",
    fill: "#FFCABF"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4732 78.7275H34.6411V74.8648H34.4732V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1167 78.7275H34.2847V74.8648H34.1167V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7603 78.7275H33.9282V74.8648H33.7603V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4033 78.7275H33.5713V74.8648H33.4033V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0254 78.7275H33.1934V74.8648H33.0254V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6685 78.7275H32.8364V74.8648H32.6685V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3125 78.7275H32.4805V74.8648H32.3125V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9336 78.7275H32.1016V74.8648H31.9336V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5772 78.7275H31.7451V74.8648H31.5772V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1997 78.7275H31.3677V74.8648H31.1997V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8633 78.7275H31.0312V74.8648H30.8633V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4854 78.7275H30.6533V74.8648H30.4854V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1289 78.7275H30.2969V74.8648H30.1289V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.772 78.7275H29.9399V74.8648H29.772V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4151 78.7275H29.583V74.8648H29.4151V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0371 78.7275H29.2051V74.8648H29.0371V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6602 78.7275H28.8281V74.8648H28.6602V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3238 78.7275H28.4917V74.8648H28.3238V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9448 78.7275H28.1128V74.8648H27.9448V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5884 78.7275H27.7563V74.8648H27.5884V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2315 78.7275H27.3994V74.8648H27.2315V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8745 78.7275H27.0425V74.8648H26.8745V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4966 78.7275H26.6646V74.8648H26.4966V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1187 78.7275H26.2866V74.8648H26.1187V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7832 78.7275H25.9512V74.8648H25.7832V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4053 78.7275H25.5732V74.8648H25.4053V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0484 78.7275H25.2163V74.8648H25.0484V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6914 78.7275H24.8594V74.8648H24.6914V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.335 78.7275H24.5029V74.8648H24.335V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9561 78.7275H24.124V74.8648H23.9561V78.7275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6001 78.7275H23.7681V74.8648H23.6001V78.7275Z",
    fill: "black"
  }))), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5567 83.6191H35.5874V79.0636H31.5567V83.6191Z",
    fill: "#5E6F7A"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9355 83.2822H35.2104V79.4195H31.9355V83.2822Z",
    fill: "#5E6F7A"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4873 83.2822H33.6553V79.4195H33.4873V83.2822Z",
    fill: "#5E6F7A"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7794 83.6191H31.5566V79.0636H19.7794V83.6191Z",
    fill: "#5E6F7A"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1363 83.2803H31.1997V79.4175H20.1363V83.2803Z",
    fill: "#5E6F7A"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.1363 83.2803H31.1997V79.4175H20.1363V83.2803Z",
    fill: "#5E6F7A"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.0093 83.2803H31.1772V79.4175H31.0093V83.2803Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.6748 83.2803H30.8428V79.4175H30.6748V83.2803Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.2964 83.2803H30.4644V79.4175H30.2964V83.2803Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.9395 83.2803H30.1074V79.4175H29.9395V83.2803Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.583 83.2803H29.751V79.4175H29.583V83.2803Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.2261 83.2803H29.394V79.4175H29.2261V83.2803Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.8482 83.2803H29.0161V79.4175H28.8482V83.2803Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.4693 83.2803H28.6372V79.4175H28.4693V83.2803Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.1343 83.2803H28.3022V79.4175H28.1343V83.2803Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.7559 83.2803H27.9238V79.4175H27.7559V83.2803Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.3989 83.2803H27.5669V79.4175H27.3989V83.2803Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.043 83.2803H27.2109V79.4175H27.043V83.2803Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26.6861 83.2803H26.854V79.4175H26.6861V83.2803Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26.3076 83.2803H26.4756V79.4175H26.3076V83.2803Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.9297 83.2803H26.0977V79.4175H25.9297V83.2803Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.5938 83.2803H25.7617V79.4175H25.5938V83.2803Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.2158 83.2803H25.3838V79.4175H25.2158V83.2803Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.8594 83.2803H25.0273V79.4175H24.8594V83.2803Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.5025 83.2803H24.6704V79.4175H24.5025V83.2803Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.1455 83.2803H24.3135V79.4175H24.1455V83.2803Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.7671 83.2803H23.9351V79.4175H23.7671V83.2803Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.4102 83.2803H23.5781V79.4175H23.4102V83.2803Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.0542 83.2803H23.2222V79.4175H23.0542V83.2803Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.6753 83.2803H22.8433V79.4175H22.6753V83.2803Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.3189 83.2803H22.4868V79.4175H22.3189V83.2803Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.9409 83.2803H22.1089V79.4175H21.9409V83.2803Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.6045 83.2803H21.7725V79.4175H21.6045V83.2803Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.2271 83.2803H21.395V79.4175H21.2271V83.2803Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.8706 83.2803H21.0386V79.4175H20.8706V83.2803Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.5127 83.2803H20.6807V79.4175H20.5127V83.2803Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.1363 83.2803H20.3042V79.4175H20.1363V83.2803Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6597 83.6182H21.6904V79.0626H17.6597V83.6182Z",
    fill: "#FFCABF"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.0371 83.2822H21.312V79.4195H18.0371V83.2822Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.5913 83.2822H19.7593V79.4195H19.5913V83.2822Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90345 83.6182H17.6807V79.0626H5.90345V83.6182Z",
    fill: "#FFCABF"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.90345 83.6182H17.6807V79.0626H5.90345V83.6182Z",
    fill: "black"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.23978 83.2793H17.3032V79.4165H6.23978V83.2793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M6.23978 83.2793H17.3032V79.4165H6.23978V83.2793Z",
    fill: "black"
  }))), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.1343 83.2793H17.3022V79.4165H17.1343V83.2793Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.7779 83.2793H16.9458V79.4165H16.7779V83.2793Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.4214 83.2793H16.5894V79.4165H16.4214V83.2793Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.0645 83.2793H16.2324V79.4165H16.0645V83.2793Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.6865 83.2793H15.8545V79.4165H15.6865V83.2793Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.3296 83.2793H15.4976V79.4165H15.3296V83.2793Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.9732 83.2793H15.1411V79.4165H14.9732V83.2793Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.5943 83.2793H14.7622V79.4165H14.5943V83.2793Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.2378 83.2793H14.4058V79.4165H14.2378V83.2793Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.8604 83.2793H14.0283V79.4165H13.8604V83.2793Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.5239 83.2793H13.6919V79.4165H13.5239V83.2793Z",
    fill: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.146 83.2793H13.314V79.4165H13.146V83.2793Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.7896 83.2793H12.9575V79.4165H12.7896V83.2793Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.4326 83.2793H12.6006V79.4165H12.4326V83.2793Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.0757 83.2793H12.2437V79.4165H12.0757V83.2793Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.6978 83.2793H11.8657V79.4165H11.6978V83.2793Z",
    fill: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.3208 83.2793H11.4888V79.4165H11.3208V83.2793Z",
    fill: "black"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.9844 83.2793H11.1523V79.4165H10.9844V83.2793Z",
    fill: "black"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.6055 83.2793H10.7734V79.4165H10.6055V83.2793Z",
    fill: "black"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.249 83.2793H10.417V79.4165H10.249V83.2793Z",
    fill: "black"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.89211 83.2793H10.0601V79.4165H9.89211V83.2793Z",
    fill: "black"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.53518 83.2793H9.70312V79.4165H9.53518V83.2793Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.15725 83.2793H9.3252V79.4165H9.15725V83.2793Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.77932 83.2793H8.94727V79.4165H8.77932V83.2793Z",
    fill: "black"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.44387 83.2793H8.61182V79.4165H8.44387V83.2793Z",
    fill: "black"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.06594 83.2793H8.23389V79.4165H8.06594V83.2793Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.70901 83.2793H7.87695L7.87695 79.4165H7.70901L7.70901 83.2793Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.35207 83.2793H7.52002L7.52002 79.4165H7.35207L7.35207 83.2793Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M6.99563 83.2793H7.16357L7.16357 79.4165H6.99563L6.99563 83.2793Z",
    fill: "black"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M6.61672 83.2793H6.78467L6.78467 79.4165H6.61672L6.61672 83.2793Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M6.26125 83.2793H6.4292L6.4292 79.4165H6.26125L6.26125 83.2793Z",
    fill: "black"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M19.004 79.0625H23.0347V74.507H19.004V79.0625Z",
    fill: "#5E6F7A"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3808 78.7256H22.6558V74.8628H19.3808V78.7256Z",
    fill: "#5E6F7A"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9351 78.7256H21.103V74.8628H20.9351V78.7256Z",
    fill: "#5E6F7A"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20569 79.0625H18.9829V74.507H7.20569V79.0625Z",
    fill: "#5E6F7A"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56253 78.7246H18.626V74.8618H7.56253V78.7246Z",
    fill: "#5E6F7A"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.56253 78.7246H18.626V74.8618H7.56253V78.7246Z",
    fill: "#5E6F7A"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.4561 78.7246H18.624V74.8618H18.4561V78.7246Z",
    fill: "black"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.0991 78.7246H18.2671V74.8618H18.0991V78.7246Z",
    fill: "black"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.7432 78.7246H17.9111V74.8618H17.7432V78.7246Z",
    fill: "black"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.3662 78.7246H17.5342V74.8618H17.3662V78.7246Z",
    fill: "black"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.9883 78.7246H17.1562V74.8618H16.9883V78.7246Z",
    fill: "black"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.6519 78.7246H16.8198V74.8618H16.6519V78.7246Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.2749 78.7246H16.4429V74.8618H16.2749V78.7246Z",
    fill: "black"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.9165 78.7246H16.0845V74.8618H15.9165V78.7246Z",
    fill: "black"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.5606 78.7246H15.7285V74.8618H15.5606V78.7246Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.2036 78.7246H15.3716V74.8618H15.2036V78.7246Z",
    fill: "black"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.8252 78.7246H14.9932V74.8618H14.8252V78.7246Z",
    fill: "black"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.4683 78.7246H14.6362V74.8618H14.4683V78.7246Z",
    fill: "black"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.1114 78.7246H14.2793V74.8618H14.1114V78.7246Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.7334 78.7246H13.9014V74.8618H13.7334V78.7246Z",
    fill: "black"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.3765 78.7246H13.5444V74.8618H13.3765V78.7246Z",
    fill: "black"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.02 78.7246H13.188V74.8618H13.02V78.7246Z",
    fill: "black"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.6631 78.7246H12.8311V74.8618H12.6631V78.7246Z",
    fill: "black"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.2847 78.7246H12.4526V74.8618H12.2847V78.7246Z",
    fill: "black"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.9278 78.7246H12.0957V74.8618H11.9278V78.7246Z",
    fill: "black"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.5718 78.7246H11.7397V74.8618H11.5718V78.7246Z",
    fill: "black"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.1929 78.7246H11.3608V74.8618H11.1929V78.7246Z",
    fill: "black"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.8364 78.7246H11.0044V74.8618H10.8364V78.7246Z",
    fill: "black"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.459 78.7246H10.627V74.8618H10.459V78.7246Z",
    fill: "black"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.1226 78.7246H10.2905V74.8618H10.1226V78.7246Z",
    fill: "black"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.74465 78.7246H9.9126V74.8618H9.74465V78.7246Z",
    fill: "black"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.38772 78.7246H9.55566V74.8618H9.38772V78.7246Z",
    fill: "black"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.03127 78.7246H9.19922V74.8618H9.03127V78.7246Z",
    fill: "black"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.67434 78.7246H8.84229V74.8618H8.67434V78.7246Z",
    fill: "black"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.29641 78.7246H8.46436V74.8618H8.29641V78.7246Z",
    fill: "black"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.91848 78.7246H8.08643V74.8618H7.91848L7.91848 78.7246Z",
    fill: "black"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.58254 78.7246H7.75049L7.75049 74.8618H7.58254L7.58254 78.7246Z",
    fill: "black"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35473 94.5963H65.8803C65.8803 94.5963 68.3995 89.7888 68.6305 89.4739C68.8614 89.159 74.3616 85.6321 74.7185 85.2123C75.0754 84.7924 76.272 80.9506 76.272 80.6777H51.7939L49.2327 83.5958H2.94255V84.7924H0.52832L2.35473 94.5753V94.5963Z",
    fill: "#5E6F7A"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68262 91.0264L2.3544 94.5952H65.88C65.88 94.5952 66.9507 92.5379 67.7694 91.0264H1.68262Z",
    fill: "#FF8066"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93039 84.5195H45.2661V84.3306H3.93039V84.5195Z",
    fill: "#ECECEC"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5523 84.7539H44.6782V84.334H44.5523V84.7539Z",
    fill: "#ECECEC"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M43.104 84.7539H43.23V84.334H43.104V84.7539Z",
    fill: "#ECECEC"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6763 84.7539H41.8022V84.334H41.6763V84.7539Z",
    fill: "#ECECEC"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2481 84.7539H40.374V84.334H40.2481V84.7539Z",
    fill: "#ECECEC"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8213 84.7539H38.9473V84.334H38.8213V84.7539Z",
    fill: "#ECECEC"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3936 84.7539H37.5195V84.334H37.3936V84.7539Z",
    fill: "#ECECEC"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9448 84.7539H36.0708V84.334H35.9448V84.7539Z",
    fill: "#ECECEC"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5166 84.7539H34.6426V84.334H34.5166V84.7539Z",
    fill: "#ECECEC"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0899 84.7539H33.2158V84.334H33.0899V84.7539Z",
    fill: "#ECECEC"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6621 84.7539H31.7881V84.334H31.6621V84.7539Z",
    fill: "#ECECEC"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2559 84.7539H30.3818V84.334H30.2559V84.7539Z",
    fill: "#ECECEC"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 84.7539H28.9541V84.334H28.8281V84.7539Z",
    fill: "#ECECEC"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3794 84.7539H27.5054V84.334H27.3794V84.7539Z",
    fill: "#ECECEC"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9517 84.7539H26.0776V84.334H25.9517V84.7539Z",
    fill: "#ECECEC"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5244 84.7539H24.6504V84.334H24.5244V84.7539Z",
    fill: "#ECECEC"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0962 84.7539H23.2222V84.334H23.0962V84.7539Z",
    fill: "#ECECEC"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6704 84.7539H21.7964V84.334H21.6704V84.7539Z",
    fill: "#ECECEC"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2207 84.7539H20.3467V84.334H20.2207V84.7539Z",
    fill: "#ECECEC"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7935 84.7539H18.9194V84.334H18.7935V84.7539Z",
    fill: "#ECECEC"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3653 84.7539H17.4912V84.334H17.3653V84.7539Z",
    fill: "#ECECEC"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 84.7539H16.0635V84.334H15.9375V84.7539Z",
    fill: "#ECECEC"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5313 84.7539H14.6572V84.334H14.5313V84.7539Z",
    fill: "#ECECEC"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M13.083 84.7539H13.209V84.334H13.083V84.7539Z",
    fill: "#ECECEC"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6558 84.7539H11.7817V84.334H11.6558V84.7539Z",
    fill: "#ECECEC"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2276 84.7539H10.3535V84.334H10.2276V84.7539Z",
    fill: "#ECECEC"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80031 84.7539H8.92627V84.334H8.80031V84.7539Z",
    fill: "#ECECEC"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37306 84.7539H7.49902V84.334H7.37306V84.7539Z",
    fill: "#ECECEC"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94533 84.7539H6.07129V84.334H5.94533V84.7539Z",
    fill: "#ECECEC"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49709 84.7539H4.62305V84.334H4.49709V84.7539Z",
    fill: "#ECECEC"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5286 81.4531H73.7539V81.1382H71.5286V81.4531Z",
    fill: "#ECECEC"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6028 81.4531H69.8281V81.1382H67.6028V81.4531Z",
    fill: "#ECECEC"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6566 81.4531H65.8818V81.1382H63.6566V81.4531Z",
    fill: "#ECECEC"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7508 81.4531H61.9761V81.1382H59.7508V81.4531Z",
    fill: "#ECECEC"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M55.826 81.4531H58.0513V81.1382H55.826V81.4531Z",
    fill: "#ECECEC"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9002 81.4531H54.1255V81.1382H51.9002V81.4531Z",
    fill: "#ECECEC"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M127.307 44.7187C139.412 44.7187 149.224 34.9061 149.224 22.8017C149.224 10.6973 139.412 0.884766 127.307 0.884766C115.203 0.884766 105.39 10.6973 105.39 22.8017C105.39 34.9061 115.203 44.7187 127.307 44.7187Z",
    fill: "#077D8B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3474_12958",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 0,
    width: 45,
    height: 45
  }, _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M127.307 44.7197C139.412 44.7197 149.224 34.9071 149.224 22.8027C149.224 10.6983 139.412 0.885742 127.307 0.885742C115.203 0.885742 105.39 10.6983 105.39 22.8027C105.39 34.9071 115.203 44.7197 127.307 44.7197Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3474_12958)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.901 31.8913L141.562 26.8739C141.373 27.0838 141.247 27.4407 141.415 27.6926C141.52 27.8606 141.709 27.9655 141.876 28.0705C142.38 28.3644 142.884 28.6373 143.409 28.9312C143.535 29.0152 143.682 29.0782 143.85 29.0782C143.976 29.0782 144.081 29.0152 144.207 29.0152C144.354 29.0152 144.501 29.0782 144.648 29.1621C145.13 29.4141 145.613 29.687 146.096 29.9389C146.264 30.0439 146.453 30.1278 146.6 30.2748C146.663 30.3378 146.726 30.4217 146.81 30.4847C147.083 30.6947 147.461 30.6107 147.776 30.5057C148.049 30.4217 148.363 30.3168 148.636 30.4427C148.741 30.4847 148.846 30.5897 148.951 30.6107C149.119 30.6527 149.308 30.5477 149.434 30.4217C149.56 30.2958 149.665 30.1278 149.812 30.0229C150.316 29.624 150.463 30.4427 150.904 30.3168C151.093 30.2538 151.135 30.0019 151.135 29.7919C151.135 29.54 151.135 29.2881 151.114 29.0362C151.114 28.8682 151.114 28.7003 150.988 28.5743C150.82 28.4064 150.547 28.4274 150.358 28.3014C150.085 28.1125 150.106 27.6506 149.833 27.4407C149.497 27.1888 148.909 27.4407 148.636 27.1468C148.384 26.8739 148.636 26.412 148.447 26.0761C148.342 25.8872 148.153 25.8032 147.965 25.7402C147.776 25.6773 147.566 25.6143 147.419 25.4883C147.167 25.2574 147.167 24.4806 147.629 24.4387C147.86 24.4387 148.069 24.6696 148.3 24.5856C148.468 24.5226 148.531 24.3127 148.468 24.1448C148.405 23.9768 148.258 23.8718 148.132 23.7459C147.755 23.431 147.377 23.1161 146.915 22.9271C146.726 22.8432 146.516 22.7802 146.348 22.6542C146.012 22.3603 146.054 21.8145 146.117 21.3736C146.138 21.2267 146.243 21.0168 146.39 21.1007C146.453 21.1217 146.474 21.2057 146.516 21.2267C146.663 21.3527 146.873 21.1217 146.852 20.9328C146.831 20.7438 146.684 20.6179 146.579 20.4499C146.432 20.198 146.411 19.8621 146.558 19.6102C146.684 19.3373 146.957 19.1484 147.251 19.1274C147.482 19.1064 147.776 19.1274 147.86 18.9174C147.902 18.7915 147.839 18.6445 147.881 18.5186C147.944 18.3926 148.111 18.3506 148.258 18.3716C148.405 18.3716 148.531 18.4556 148.678 18.4346C148.972 18.3926 149.161 18.0567 149.455 18.0357C149.644 18.0357 149.854 18.1407 150.022 18.0357C150.232 17.9308 150.211 17.6159 150.337 17.4059C150.463 17.175 150.757 17.091 151.03 17.091C151.302 17.091 151.554 17.175 151.827 17.175C152.058 17.175 152.184 17.07 152.352 16.9441C152.478 16.8601 152.583 16.7761 152.667 16.6502C152.751 16.5242 152.793 16.3772 152.73 16.2303C152.604 15.9784 152.1 15.9154 151.911 16.1253C151.848 16.1883 151.827 16.2933 151.722 16.3143C151.638 16.3143 151.575 16.2303 151.491 16.1883C151.323 16.0414 151.072 16.0833 150.862 16.1043C150.778 16.1043 150.715 16.1253 150.631 16.1043C150.547 16.1043 150.484 16.0624 150.442 15.9784C150.421 15.9364 150.4 15.8734 150.4 15.8104C150.379 15.5585 150.358 15.2856 150.337 15.0337C150.337 14.8237 150.337 14.5718 150.211 14.3829C150.001 14.068 149.665 13.7741 149.35 14.152C149.203 14.3409 149.035 15.3696 148.594 15.0127C148.468 14.9077 148.489 14.6978 148.594 14.5508C148.699 14.4039 148.825 14.2989 148.93 14.173C149.014 14.026 149.056 13.8161 148.93 13.7111C148.762 13.5642 148.51 13.7111 148.342 13.8791C148.174 14.026 147.923 14.173 147.755 14.026C147.545 13.8371 147.797 13.4802 147.692 13.2493C147.629 13.1233 147.461 13.0393 147.419 12.8924C147.314 12.6195 147.671 12.3885 147.713 12.0946C147.755 11.8217 147.503 11.5908 147.356 11.3389C147.167 10.982 147.209 10.5411 146.999 10.2052C146.789 9.82735 146.369 9.65941 146.033 9.40749C145.655 9.13457 145.34 8.77769 145.088 8.39981C144.963 8.21087 144.921 8.04292 144.837 7.83299C144.732 7.62306 144.606 7.43412 144.48 7.22419C144.312 6.93028 144.186 6.59439 144.249 6.2585C144.354 5.75466 144.081 5.08287 143.997 4.55804C143.976 4.43208 143.955 4.28513 143.997 4.15917C144.039 3.97023 144.165 3.78129 144.123 3.59235C144.039 3.34043 143.724 3.29845 143.556 3.10951C143.409 2.92057 143.388 2.60567 143.157 2.54269C142.947 2.47971 142.779 2.68964 142.653 2.85759C142.485 3.10951 142.317 3.42441 142.443 3.69732C142.485 3.78129 142.548 3.86527 142.569 3.94924C142.611 4.09619 142.527 4.26414 142.401 4.3691C142.254 4.47407 142.044 4.45308 141.918 4.53705C141.772 4.64202 141.751 4.78897 141.646 4.93592C141.52 5.12486 141.289 5.20883 141.058 5.22983C140.827 5.25082 140.596 5.22983 140.386 5.29281C139.084 5.67069 140.218 7.11922 140.218 7.91696C140.218 8.02193 140.218 8.1269 140.218 8.23186C140.218 8.33683 140.092 8.4418 140.008 8.4208C139.861 8.39981 139.693 8.35782 139.546 8.31584C139.315 8.25286 139.126 8.27385 139 8.48378C138.937 8.58875 138.832 8.69372 138.728 8.7567C138.581 8.86166 138.476 9.00861 138.371 9.15557C138.14 9.47047 137.993 9.59643 138.392 10.0373C138.434 10.0793 138.455 10.1213 138.476 10.1632C138.518 10.2682 138.476 10.3732 138.434 10.4571C138.371 10.5621 138.245 10.6041 138.161 10.5621C137.783 10.3732 137.363 10.2892 137.027 10.0163C136.964 9.9743 136.88 9.9743 136.796 9.95331C136.607 9.89033 136.502 10.3102 136.439 10.4152C136.418 10.4571 136.397 10.5201 136.397 10.5621C136.397 10.6041 136.418 10.6671 136.439 10.7091C136.439 10.835 136.334 10.961 136.208 11.024C136.103 11.0869 135.956 11.1079 135.851 11.024C135.746 10.94 135.725 10.793 135.704 10.6461C135.662 10.3312 135.6 10.0373 135.516 9.74338C135.474 9.55444 135.537 9.28153 135.39 9.13457C135.285 9.02961 135.138 9.02961 135.117 8.84067C135.075 8.4208 135.579 8.67272 135.767 8.71471C135.893 8.7567 136.019 8.7567 136.145 8.79868C136.292 8.84067 136.439 8.92464 136.586 8.94563C136.775 8.96663 136.964 8.94563 137.111 8.86166C137.216 8.79868 137.3 8.69372 137.405 8.63074C137.489 8.58875 137.594 8.58875 137.678 8.52577C137.783 8.4418 137.762 8.29484 137.804 8.16888C137.804 8.06392 137.867 7.95895 137.951 7.89597C138.035 7.83299 138.14 7.79101 138.245 7.812C138.287 7.812 138.35 7.85398 138.392 7.83299C138.497 7.83299 138.539 7.70703 138.56 7.60207C138.644 6.74134 137.552 6.42644 136.901 6.19552C136.04 5.88062 135.39 5.22983 134.487 4.97791C133.983 4.83096 133.5 4.76798 133.101 4.3901C132.975 4.26414 132.87 4.13818 132.702 4.0752C132.618 4.03321 132.513 4.03321 132.451 3.94924C132.367 3.86527 132.367 3.7603 132.346 3.65533C132.283 3.4454 132.136 3.25646 131.947 3.1305C131.422 2.77362 130.708 2.68964 130.12 2.96256C129.994 3.02554 129.868 3.08851 129.721 3.08851C129.616 3.08851 129.511 3.00454 129.406 2.98355C129.302 2.98355 129.218 3.02553 129.113 3.06752C128.714 3.23547 128.336 3.42441 127.937 3.59235C127.748 3.67633 127.538 3.7603 127.37 3.90725C127.244 4.01222 127.139 4.11718 126.992 4.22215C126.74 4.41109 126.446 4.51606 126.153 4.57904C125.901 4.64202 125.691 4.76798 125.46 4.87294C125.04 5.08287 124.683 5.52373 124.473 5.92261C124.368 6.13254 124.284 6.36346 124.305 6.59439C124.305 6.65737 124.326 6.76234 124.368 6.80432C124.389 6.84631 124.452 6.8673 124.494 6.88829C124.578 6.97227 124.62 7.09823 124.62 7.22419C124.62 7.39213 124.536 7.53909 124.473 7.68604C124.41 7.83299 124.326 7.97994 124.2 8.04292C124.137 8.08491 124.074 8.08491 124.032 8.1269C123.927 8.18988 123.885 8.29484 123.864 8.4208C123.843 8.54676 123.822 8.65173 123.801 8.7567C123.759 8.96663 123.633 9.13457 123.528 9.32351C123.423 9.51245 123.36 9.70139 123.381 9.91132C123.402 10.1003 123.381 10.3102 123.318 10.4991C123.151 10.877 122.731 11.066 122.542 11.4228C122.332 11.8007 122.185 12.2836 121.786 12.4935C121.639 12.5775 121.45 12.5985 121.282 12.6824C121.135 12.7454 121.03 12.8714 120.904 12.9763C120.589 13.2702 120.023 13.6271 119.813 13.984C119.624 14.3199 119.834 14.7608 119.666 15.1177C119.666 15.1177 119.666 15.1596 119.666 15.2016C119.729 15.4116 119.876 15.5585 119.96 15.7475C120.023 15.8734 120.085 15.9784 120.106 16.1043C120.106 16.1673 120.106 16.2513 120.064 16.3143C120.002 16.3982 119.918 16.4612 119.876 16.5452C119.834 16.5872 119.876 16.7341 119.918 16.7551C119.981 16.7971 120.064 16.8181 120.127 16.8391C120.211 16.8811 120.253 16.9651 120.19 17.028C120.127 17.112 120.043 17.196 120.002 17.28C119.96 17.3429 119.981 17.5109 120.043 17.5739C120.316 17.8258 120.631 18.0357 120.967 18.1407C121.009 18.1407 121.072 18.1827 121.114 18.1407C121.429 18.0357 121.786 17.9727 121.996 17.6578C122.08 17.5319 122.185 17.3849 122.29 17.301C122.5 17.154 122.794 17.112 122.899 16.8391C122.899 16.8391 122.941 16.8391 122.962 16.8391C123.046 16.9021 123.15 16.9651 123.171 17.049C123.213 17.196 123.213 17.3639 123.255 17.5109C123.297 17.6788 123.423 17.8468 123.423 18.0357C123.444 18.3506 123.591 18.5815 123.738 18.8335C123.864 19.0644 123.99 19.2953 124.158 19.5052C124.242 19.6102 124.2 19.8411 124.2 19.9671C124.2 20.0301 124.2 20.114 124.242 20.177C124.263 20.219 124.305 20.24 124.326 20.282C124.389 20.408 124.368 20.5339 124.557 20.5549C124.683 20.5549 124.851 20.5129 124.977 20.4919C125.103 20.4919 125.145 20.387 125.166 20.282C125.208 20.0931 125.313 20.0091 125.481 19.9881C125.565 19.9881 125.628 19.9671 125.712 19.9671C125.943 19.9671 126.132 19.9251 126.237 19.6942C126.593 19.7572 126.572 19.4633 126.635 19.2533C126.635 19.2113 126.635 19.1484 126.635 19.1064C126.635 19.0224 126.572 18.9804 126.488 19.0014C126.467 19.0014 126.425 19.0014 126.404 19.0014C126.404 19.0014 126.362 18.9594 126.362 18.9384C126.362 18.6865 126.341 18.4136 126.425 18.1617C126.467 18.0357 126.488 17.9098 126.488 17.7838C126.488 17.5319 126.614 17.3849 126.803 17.259C126.929 17.175 127.076 17.112 127.202 17.007C127.328 16.8811 127.454 16.7341 127.412 16.5242C127.412 16.4192 127.433 16.3143 127.433 16.2093C127.433 16.1253 127.433 16.0414 127.37 15.9784C127.181 15.7265 127.013 15.4535 126.698 15.3276C126.53 15.2646 126.467 15.1177 126.467 14.9497C126.467 14.5298 126.467 14.11 126.509 13.6901C126.509 13.6061 126.551 13.5432 126.593 13.4802C126.803 13.1233 127.055 12.7874 127.412 12.5565C127.58 12.4515 127.748 12.3046 127.895 12.1576C128.189 11.8637 128.189 11.8637 128.357 11.4438C128.42 11.3179 128.42 11.1919 128.378 11.066C128.315 10.7511 128.378 10.3942 128.504 10.1632C128.63 9.91132 128.798 9.72238 129.113 9.78536C129.49 9.72238 129.847 9.78537 130.183 9.9743C130.288 10.0163 130.33 10.2682 130.246 10.3102C130.12 10.3732 130.036 10.4362 130.036 10.6041C130.036 10.7091 129.994 10.814 129.931 10.898C129.679 11.2759 129.469 11.6538 129.176 11.9897C129.092 12.0946 129.008 12.1786 128.966 12.3046C128.903 12.4935 128.777 12.5355 128.588 12.5145C128.483 12.5145 128.441 12.5565 128.441 12.6614C128.462 12.7874 128.441 12.9134 128.399 13.0393C128.378 13.1443 128.399 13.2493 128.399 13.3542C128.399 13.4592 128.462 13.5432 128.483 13.6481C128.609 14.2149 128.63 14.8028 128.924 15.3066C129.197 15.7684 129.763 16.1673 129.742 16.7551C129.742 17.07 129.532 17.3849 129.637 17.6788C129.889 18.4136 129.805 18.3506 129.281 18.8964C128.777 19.4213 128.987 19.9041 129.071 20.5969C129.071 20.6389 129.029 20.7019 129.008 20.7229C128.882 20.7858 128.777 20.8278 128.651 20.8698C128.525 20.9118 128.441 21.0168 128.42 21.1637C128.378 21.4156 127.895 21.4576 127.769 21.2687C127.748 21.2267 127.706 21.1847 127.685 21.1217C127.622 20.9748 127.496 20.9328 127.349 20.9538C127.076 20.9748 126.824 21.0378 126.593 21.1847C126.278 21.3736 125.964 21.5626 125.628 21.7305C125.397 21.8355 125.271 22.1924 124.998 21.9405C124.83 21.7725 124.683 21.3527 124.41 21.3527C124.326 21.3527 124.263 21.3946 124.2 21.3946C124.053 21.3946 123.948 21.2477 123.864 21.1217C123.843 21.0797 123.801 21.0168 123.801 20.9748C123.801 20.9328 123.801 20.8908 123.801 20.8278C123.801 20.6389 123.675 20.4499 123.507 20.366C123.36 20.303 123.13 20.4499 123.067 20.219C123.067 20.156 123.067 20.114 123.067 20.0511C123.067 19.9881 123.088 19.9251 123.109 19.8621C123.109 19.8411 123.109 19.7992 123.109 19.7782C123.109 19.6522 122.899 19.5682 122.836 19.4633C122.731 19.2953 122.794 19.1064 122.71 18.9384C122.668 18.8545 122.563 18.7705 122.458 18.7705C122.395 18.7705 122.332 18.7915 122.269 18.8125C122.143 18.8754 122.017 18.9384 121.912 19.0014C121.87 19.0224 121.807 19.0644 121.786 19.1274C121.744 19.2113 121.786 19.3163 121.765 19.4213C121.765 19.5052 121.681 19.5892 121.639 19.6732C121.513 19.9041 121.639 20.0931 121.555 20.303C121.513 20.408 121.555 20.5129 121.618 20.5969C121.66 20.6599 121.744 20.7229 121.744 20.7858C121.807 21.1217 121.933 21.4366 121.954 21.7725C121.954 21.9615 121.723 22.2134 121.555 22.1714C121.345 22.1084 121.156 22.1294 120.946 22.2344C120.778 22.3183 120.61 22.4023 120.442 22.4233C120.211 22.4653 120.002 22.5913 119.792 22.6962C119.603 22.8012 119.477 22.9481 119.414 23.1581C119.204 23.8718 119.183 23.8718 118.637 24.2917C118.511 24.3967 118.364 24.4387 118.238 24.5226C118.175 24.5646 118.112 24.6276 118.091 24.6906C118.049 24.7955 118.049 24.9005 118.007 24.9845C117.965 25.1524 117.839 25.2574 117.692 25.2994C117.608 25.3204 117.545 25.3414 117.461 25.3624C117.335 25.4044 117.23 25.4883 117.167 25.6143C117.083 25.7822 116.915 25.7822 116.769 25.7612C116.643 25.7612 116.517 25.6773 116.412 25.5933C116.349 25.5513 116.265 25.5513 116.202 25.5513C116.118 25.5513 116.034 25.6353 116.055 25.6983C116.097 25.8452 116.139 25.9922 116.16 26.1601C116.181 26.2651 116.097 26.349 115.971 26.37C115.782 26.37 115.614 26.37 115.425 26.2861C115.341 26.2441 115.215 26.2231 115.131 26.2441C114.921 26.2861 114.732 26.349 114.522 26.412C114.459 26.412 114.396 26.538 114.417 26.601C114.459 26.8529 114.48 27.1258 114.858 27.1468C115.005 27.1468 115.152 27.2728 115.299 27.3147C115.551 27.3777 115.74 27.5247 115.803 27.7556C115.887 27.9865 116.013 28.1755 116.223 28.3014C116.391 28.3854 116.433 28.5323 116.412 28.7003C116.412 29.1202 116.37 29.54 116.328 29.9599C116.328 30.1068 116.265 30.2748 116.202 30.4217C116.16 30.5477 115.95 30.6947 115.824 30.6317C115.551 30.5267 115.257 30.6737 114.984 30.5267C114.921 30.4847 114.816 30.4847 114.753 30.5267C114.48 30.6317 114.228 30.5897 113.976 30.5267C113.704 30.4427 113.41 30.3798 113.137 30.4637C113.053 30.4637 112.969 30.4637 112.906 30.4637C112.57 30.3378 112.297 30.3378 112.045 30.6527C112.003 30.6947 111.898 30.6947 111.835 30.7366C111.793 30.7366 111.73 30.7786 111.688 30.7996C111.604 30.8416 111.541 30.9886 111.583 31.0725C111.73 31.3245 111.814 31.5974 111.751 31.8913C111.751 31.9123 111.751 31.9333 111.751 31.9752C111.877 32.5631 111.751 33.1299 111.499 33.6547C111.436 33.8017 111.373 33.9486 111.331 34.0956C111.289 34.2005 111.289 34.3055 111.373 34.3895C111.604 34.6624 111.709 34.9773 111.667 35.3342C111.667 35.3762 111.667 35.4391 111.667 35.4811C111.667 35.5231 111.709 35.5861 111.751 35.6071C111.94 35.6701 112.15 35.775 112.36 35.712C112.801 35.5861 113.2 35.901 113.641 35.964C114.039 36.0269 115.824 36.1319 116.076 35.754C116.16 35.6071 116.286 35.5231 116.454 35.4811C116.622 35.4391 116.727 35.3342 116.769 35.1662C116.832 34.9353 116.957 34.7254 117.125 34.5574C117.209 34.4734 117.251 34.3685 117.167 34.2635C116.853 33.8856 117.02 33.5917 117.293 33.2978C117.356 33.2138 117.44 33.1299 117.503 33.0669C117.713 32.836 117.902 32.5631 118.238 32.5421C118.595 32.3741 118.868 32.1642 118.868 31.7233C118.868 31.5764 118.889 31.4084 118.91 31.2615C118.91 31.1775 118.931 31.1145 118.952 31.0305C119.015 30.8416 119.246 30.6737 119.435 30.7156C119.792 30.7996 120.169 30.7786 120.484 31.0096C120.631 31.1145 120.799 31.0725 120.904 30.9466C121.114 30.6947 121.345 30.5057 121.66 30.4007C121.744 30.3798 121.828 30.2748 121.912 30.2118C122.101 30.0019 122.311 29.9809 122.563 30.0858C122.794 30.1698 122.983 30.2958 123.088 30.5267C123.171 30.7156 123.276 30.9046 123.36 31.0935C123.696 31.3874 124.032 31.6813 124.305 32.0172C124.515 32.2691 124.767 32.4581 125.082 32.5211C125.754 32.689 126.614 33.4028 126.446 34.1795C126.404 34.3475 126.341 34.4944 126.278 34.6414C126.258 34.7254 126.216 34.8303 126.237 34.9143C126.237 34.9983 126.278 35.1032 126.362 35.1452C126.572 35.2712 126.971 35.2082 127.097 34.9983C127.223 34.7673 127.349 34.5364 127.475 34.3055C127.559 34.1585 127.538 34.0116 127.454 33.8646C127.412 33.8017 127.349 33.7387 127.328 33.6547C127.328 33.5497 127.328 33.4448 127.349 33.3398C127.391 33.1929 127.601 33.1089 127.727 33.1929C127.853 33.2768 127.958 33.4028 128.084 33.4868C128.105 33.4868 128.189 33.4868 128.21 33.4448C128.315 33.2978 128.315 33.0879 128.21 33.0249C127.79 32.794 127.454 32.4371 126.992 32.3111C126.824 32.2691 126.803 32.1642 126.782 32.0172C126.782 31.9752 126.74 31.9123 126.698 31.8913C126.593 31.8493 126.488 31.8283 126.383 31.8283C126.132 31.8283 125.922 31.7023 125.775 31.5134C125.649 31.3664 125.523 31.2195 125.46 31.0725C125.334 30.7576 125.103 30.5687 124.872 30.3378C124.767 30.2538 124.662 30.1908 124.557 30.1068C124.431 30.0019 124.368 29.8549 124.368 29.687C124.368 29.561 124.368 29.4351 124.389 29.2881C124.389 29.2041 124.452 29.1412 124.515 29.0992C124.641 29.0362 124.746 28.9942 124.872 28.9522C124.914 28.9522 124.977 28.9732 124.998 29.0152C125.04 29.1412 125.04 29.2671 125.082 29.3931C125.124 29.498 125.208 29.603 125.313 29.582C125.481 29.54 125.586 29.708 125.754 29.687C125.88 29.687 125.964 29.75 126.006 29.8549C126.111 30.2118 126.362 30.4217 126.656 30.6107C126.887 30.7576 127.118 30.9676 127.412 30.9676C127.538 31.0725 127.643 31.1775 127.811 31.1985C128 31.2195 128.147 31.3664 128.273 31.4924C128.42 31.6394 128.546 31.8073 128.693 31.9543C129.029 32.2901 128.756 33.0039 129.134 33.4238C129.323 33.6547 129.595 33.8017 129.763 34.0536C130.078 34.5154 129.973 35.1872 130.351 35.6071C130.519 35.796 130.792 35.901 131.044 35.901C131.107 35.901 131.191 35.88 131.233 35.817C131.275 35.775 131.275 35.712 131.275 35.6491C131.296 35.5021 131.422 35.3552 131.569 35.3132C132.702 34.9353 131.464 34.6414 131.611 33.9906C131.632 33.8436 131.758 33.7387 131.905 33.6757C132.472 33.4448 133.038 34.0536 133.584 33.6757C133.794 33.5287 133.92 33.2558 134.151 33.1509C134.424 33.0459 134.718 33.1929 135.012 33.2768C135.516 33.4028 136.061 33.2138 136.481 32.9199C136.607 32.815 136.754 32.752 136.88 32.647C137.027 32.5211 137.174 32.3321 137.3 32.1852C137.342 32.1432 137.384 32.1012 137.384 32.0592C137.447 31.8283 137.027 31.8493 136.901 31.8493C136.796 31.8493 136.67 31.8283 136.565 31.8493C136.418 31.8913 136.376 31.9542 136.313 32.0802C136.271 32.2062 136.124 32.3111 135.998 32.3111C135.914 32.3111 135.851 32.2482 135.788 32.2272C135.39 32.0802 134.613 32.647 134.403 31.9543C134.34 31.7233 134.424 31.4924 134.529 31.2615C134.634 31.0515 134.76 30.8416 134.781 30.5897C134.781 30.3588 134.697 30.1488 134.676 29.9179C134.613 29.2251 135.159 28.5953 135.537 28.0915C135.599 27.9865 135.767 27.9655 135.893 28.0285C135.914 28.0285 135.956 28.0285 135.956 28.0495C136.103 28.1965 136.376 28.3854 136.586 28.3434C136.88 28.3014 136.985 28.0075 136.985 27.7556C136.985 27.6086 136.985 27.4827 136.985 27.3567C137.048 27.0418 137.363 26.8529 137.636 26.7059C137.678 26.7059 137.699 26.6639 137.741 26.6849C137.804 26.6849 137.825 26.7689 137.804 26.8109C137.804 26.8739 137.762 26.9159 137.741 26.9579C137.636 27.1468 137.678 27.3987 137.846 27.5457C138.014 27.6926 138.287 27.6716 138.413 27.5037C138.497 27.3987 138.518 27.2728 138.602 27.1678C138.748 26.9579 139.063 26.9159 139.315 26.8319C140.05 26.622 140.596 26.0551 141.142 25.5093C141.226 25.4253 141.31 25.3624 141.415 25.3204C141.52 25.2784 141.667 25.3204 141.709 25.4044C141.772 25.5093 141.709 25.6563 141.646 25.7612C141.583 25.8662 141.499 25.9922 141.52 26.1181C141.541 26.2651 141.73 26.37 141.73 26.538C141.73 26.643 141.625 26.7269 141.541 26.8109L136.901 31.8913Z",
    fill: "#ACCAB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.701 18.2244C110.722 18.3504 110.806 18.4764 110.827 18.5603C110.995 18.9592 111.267 19.3161 111.351 19.736C111.393 19.9459 111.393 20.3448 111.582 20.4707C111.75 20.5967 112.002 20.4287 112.212 20.4707C112.359 20.5127 112.275 20.7016 112.359 20.8066C112.401 20.8696 112.443 20.9536 112.506 20.9956C112.632 21.0795 112.653 21.1845 112.632 21.3314C112.548 21.7303 112.464 21.7933 112.044 21.7303C112.023 21.7303 112.002 21.7303 111.96 21.7303C111.897 21.7303 111.855 21.7513 111.855 21.8143C111.855 22.0242 111.813 22.2342 112.002 22.4021C112.065 22.4651 112.044 22.633 111.96 22.696C111.876 22.759 111.792 22.822 111.708 22.8849C111.645 22.9269 111.582 22.9689 111.519 23.0319C111.372 23.1998 111.813 23.3678 111.834 23.5987C111.876 24.0816 111.498 24.2915 111.247 24.6274C111.247 24.6274 111.247 24.6904 111.247 24.7114C111.247 24.7324 111.288 24.7533 111.309 24.7533C111.393 24.7533 111.477 24.7533 111.54 24.7323C111.687 24.6694 111.813 24.5644 111.981 24.5854C112.233 24.6274 112.443 24.5854 112.59 24.3545C112.632 24.2915 112.779 24.2495 112.884 24.2705C113.157 24.2915 113.409 24.2705 113.661 24.2285C113.976 24.1655 114.27 24.1235 114.584 24.1026C114.878 24.1026 115.13 23.9556 115.34 23.7247C115.382 23.6827 115.382 23.5567 115.319 23.5147C115.277 23.4937 115.235 23.4728 115.193 23.4308C115.109 23.3678 115.088 23.3048 115.13 23.2418C115.235 23.0949 115.361 22.9479 115.424 22.78C115.592 22.4441 115.403 22.0662 115.025 22.0242C114.899 22.0242 114.773 22.0242 114.647 22.0032H114.626C114.626 21.9193 114.626 21.8563 114.605 21.7933C114.479 21.5624 114.374 21.3314 114.291 21.0795C114.249 20.9326 114.144 20.7856 113.997 20.7016C113.745 20.5757 113.619 20.3658 113.535 20.0928C113.43 19.715 113.199 19.442 112.821 19.2951C112.758 19.2741 112.737 19.2321 112.779 19.1691C112.821 19.0432 112.863 18.9172 112.926 18.8123C113.073 18.5813 113.157 18.3504 113.22 18.0775C113.262 17.9515 113.157 17.8046 113.01 17.7836C112.968 17.7836 112.905 17.7626 112.863 17.7626C112.674 17.7626 112.485 17.7626 112.317 17.7626C112.275 17.7626 112.233 17.7206 112.212 17.6786C112.212 17.6786 112.212 17.6366 112.212 17.6156C112.317 17.4897 112.401 17.3637 112.506 17.2378C112.527 17.1958 112.506 17.1328 112.506 17.0908C112.506 17.0278 112.422 16.9648 112.338 16.9648C112.128 16.9648 111.918 16.9858 111.708 17.0068C111.603 17.0068 111.519 17.0908 111.456 17.1958C111.33 17.4267 111.205 17.6576 111.079 17.8885C111.016 18.0145 110.743 17.8885 110.659 18.0985C110.659 18.1405 110.659 18.1825 110.659 18.2454L110.701 18.2244Z",
    fill: "#ACCAB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.867 20.2832C107.825 20.4091 107.783 20.5351 107.72 20.64C107.72 20.682 107.636 20.724 107.594 20.724C107.447 20.724 107.279 20.724 107.132 20.745C107.048 20.745 106.964 20.808 106.964 20.892C106.964 21.0389 106.964 21.2069 106.943 21.3538C106.901 21.5008 106.964 21.6057 107.069 21.6897C107.195 21.8157 107.195 21.9836 107.111 22.1306C107.048 22.2775 106.943 22.4035 106.859 22.5294C106.838 22.5714 106.775 22.5924 106.754 22.6344C106.607 22.7814 106.67 23.0333 106.859 23.1802C107.09 23.3482 107.342 23.3692 107.615 23.2852C107.762 23.2432 107.909 23.1592 108.035 23.0753C108.266 22.9283 108.496 22.8443 108.769 22.8023C108.874 22.8023 108.958 22.7184 109.021 22.6134C109.21 22.3195 109.294 21.9836 109.21 21.6477C109.21 21.5637 109.168 21.5008 109.168 21.4168C109.168 21.3118 109.189 21.2069 109.252 21.1229C109.273 21.0809 109.315 21.0389 109.357 21.0179C109.546 20.85 109.525 20.64 109.42 20.4511C109.378 20.3671 109.315 20.2622 109.252 20.1782C109.21 20.1152 109.147 20.0522 109.063 20.0522C108.853 20.0102 108.643 19.9893 108.454 19.9473C108.392 19.9473 108.35 19.9473 108.287 19.9683C108.098 19.9893 107.93 20.0732 107.867 20.2832Z",
    fill: "#ACCAB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.06 36.7202C132.913 36.6992 132.724 36.6782 132.619 36.7832C132.535 36.8882 132.556 37.0351 132.619 37.1401C132.703 37.245 132.85 37.287 132.976 37.266C133.165 37.266 133.396 37.1821 133.543 37.308C133.606 37.35 133.627 37.413 133.669 37.476C133.878 37.7699 134.319 37.8538 134.655 37.7279C135.012 37.6229 135.285 37.371 135.558 37.1191C135.474 37.0141 135.327 36.9931 135.18 37.0351C135.054 37.0771 134.928 37.1401 134.802 37.1611C134.592 37.1821 134.319 36.9721 134.109 36.9092C133.753 36.8252 133.375 36.7832 133.018 36.6992L133.06 36.7202Z",
    fill: "#ACCAB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.275 37.4139C139.275 37.4139 139.149 37.4559 139.107 37.4979C139.065 37.5398 139.044 37.6238 139.107 37.6658C139.128 37.6868 139.17 37.7078 139.191 37.7078C139.506 37.8337 139.82 37.9597 140.156 38.0857C140.219 38.1067 140.261 38.1277 140.324 38.1277C140.429 38.1277 140.492 38.0017 140.513 37.8967C140.534 37.7918 140.513 37.6868 140.513 37.5818C140.555 37.2879 140.828 37.099 141.059 36.931C141.29 36.7631 141.542 36.5532 141.563 36.2593C141.563 36.1753 141.542 36.0913 141.458 36.0703C141.416 36.0703 141.374 36.0703 141.332 36.0913C141.038 36.2383 140.744 36.3852 140.471 36.5951C140.24 36.7841 140.177 37.099 139.904 37.2669C139.694 37.3929 139.485 37.3719 139.254 37.4349L139.275 37.4139Z",
    fill: "#ACCAB8"
  }))), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M288.36 60.0803L290.441 61.2203L288.36 62.3603L287.22 64.4407L286.08 62.3603L284 61.2203L286.08 60.0803L287.22 58L288.36 60.0803Z",
    fill: "#FFD485"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3474_12958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.922 28.0774L270.797 29.1014L268.922 30.1255L267.898 31.9997L266.874 30.1255L265 29.1014L266.874 28.0774L267.898 26.2031L268.922 28.0774Z",
    fill: "#FFD485"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3474_12958",
    x1: 138.581,
    y1: 189.97,
    x2: 221.862,
    y2: 189.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8F8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3474_12958",
    x1: 102.661,
    y1: 171.371,
    x2: 158.944,
    y2: 171.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8F8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3474_12958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 365.472,
    height: 480.116,
    fill: "white",
    transform: "translate(0.52832 0.883789)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3474_12958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33898,
    height: 19,
    fill: "white",
    transform: "translate(265 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalReportAnimated);
export default __webpack_public_path__ + "static/media/finalReportAnimated.15662694022031904de17f3c83b0eea1.svg";
export { ForwardRef as ReactComponent };